webpackJsonp([1],{

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Quiz__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cookies__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GeneralConditions__ = __webpack_require__(117);
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
    Quiz: __WEBPACK_IMPORTED_MODULE_1__components_Quiz__["a" /* default */],
    Cookies: __WEBPACK_IMPORTED_MODULE_2__components_Cookies__["a" /* default */],
    GeneralConditions: __WEBPACK_IMPORTED_MODULE_3__components_GeneralConditions__["a" /* default */]
  }
});

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c28f9b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(210);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c28f9b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {};
  },

  methods: {
    toggleBodyClass: function toggleBodyClass(addRemoveClass, className) {
      var el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted: function mounted() {
    this.toggleBodyClass('addClass', 'home');
  },
  destroyed: function destroyed() {
    this.toggleBodyClass('removeClass', 'home');
  }
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf6ab6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__ = __webpack_require__(225);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf6ab6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebaseInit__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getGrade_js__ = __webpack_require__(114);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// A reference to the users collection.
var users = __WEBPACK_IMPORTED_MODULE_0__firebaseInit__["a" /* default */].collection('users');



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quiz',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getGrade_js__["a" /* default */]],
  data: function data() {
    return {
      step: 1,
      paramStep: null,
      province: null,
      age_category: null,
      gender: null,
      highest_education: null,
      job: null,
      unemployed: false,
      functional_level: null,
      sector: null,
      happiness: null,
      happiness_job: null,
      answers: [],
      part: null,
      important: null,
      friends: null,
      understand: null,
      control: null,
      performance: null,
      doing_well: null,
      hardest_tasks: null,
      expression: null,
      myself: null,
      want: null,
      best: null,
      meaning: null,
      matters: null,
      contribute: null,
      society: null,
      uid: Date.now() + '-' + Math.random().toString().slice(2),
      grade: null,
      errorActive: false,
      name: null,
      email: null,
      email_return: null,
      newsletter: null,
      success: false,
      opinions: [],
      checked: [],
      hideChecked: false,
      hoverActive: false,
      progressActive: false,
      nextStepActive: false,
      progressBackReverse: false,
      progressBackAnimation: false,
      leftFadeOut: false,
      leftFadeIn: false,
      rightFadeOut: false,
      rightFadeIn: false
    };
  },

  computed: {
    classResults: function classResults() {
      return {
        'results-color--red': this.grade < 6,
        'results-color--orange': this.grade >= 6 && this.grade < 7,
        'results-color--green': this.grade >= 7
      };
    },
    emotionsResults: function emotionsResults() {
      return {
        'emoticon--totally-agree': this.grade > 8,
        'emoticon--agree': this.grade >= 6 && this.grade <= 8,
        'emoticon--neutral': this.grade >= 5 && this.grade < 6,
        'emoticon--disagree': this.grade >= 3 && this.grade < 5,
        'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3
      };
    }
  },
  methods: {
    debug: function debug() {
      if (window.location.hostname != 'www.testjewerkgeluk.nl') {
        if (this.$route.query.fill) {
          this.province = 'noord_brabant';
          this.age_category = '31_35';
          this.gender = 'female';
          this.highest_education = 'basis';
          this.job = 'yes';
          this.functional_level = 'zzp_zmp';
          this.sector = 'culture_recreation_other';
          this.happiness = this.generateRandomInteger(1, 10);
          this.happiness_job = this.generateRandomInteger(1, 10);
          this.part = this.generateRandomInteger(0, 4);
          this.important = this.generateRandomInteger(0, 4);
          this.friends = this.generateRandomInteger(0, 4);
          this.understand = this.generateRandomInteger(0, 4);
          this.control = this.generateRandomInteger(0, 4);
          this.performance = this.generateRandomInteger(0, 4);
          this.doing_well = this.generateRandomInteger(0, 4);
          this.hardest_tasks = this.generateRandomInteger(0, 4);
          this.expression = this.generateRandomInteger(0, 4);
          this.myself = this.generateRandomInteger(0, 4);
          this.want = this.generateRandomInteger(0, 4);
          this.best = this.generateRandomInteger(0, 4);
          this.meaning = this.generateRandomInteger(0, 4);
          this.matters = this.generateRandomInteger(0, 4);
          this.contribute = this.generateRandomInteger(0, 4);
          this.society = this.generateRandomInteger(0, 4);
        }
        if (this.$route.query.step) {
          this.step = this.$route.query.step - 1;
          this.nextStep();
        }
        if (this.$route.query.grade) {
          this.grade = this.$route.query.grade;
        }
      }
    },
    generateRandomInteger: function generateRandomInteger(min, max) {
      return Math.floor(min + Math.random() * (max + 1 - min));
    },
    nextStep: function nextStep(switchScreen) {
      var _this = this;

      this.switchScreenReset();

      this.progressActive = true;
      this.nextStepActive = true;
      this.progressBackReverse = false;
      this.progressBackAnimation = false;
      setTimeout(function () {
        return _this.step++;
      }, 750);
      this.opinions = [];

      // Reset values.
      setTimeout(function () {
        return _this.progressActive = false;
      }, 750);
      setTimeout(function () {
        return _this.nextStepActive = false;
      }, 750);

      // Animation.
      if (switchScreen) {
        this.leftFadeOut = true;
        this.leftFadeIn = false;
        this.rightFadeIn = true;
        this.rightFadeOut = false;
      }
    },
    previousStep: function previousStep(switchScreen) {
      var _this2 = this;

      this.switchScreenReset();

      this.progressActive = false;
      this.nextStepActive = true;
      this.progressBackReverse = true;
      setTimeout(function () {
        return _this2.progressBackAnimation = true;
      }, 100);
      setTimeout(function () {
        return _this2.step--;
      }, 750);
      this.opinions = [];

      // Reset values.
      setTimeout(function () {
        return _this2.progressActive = false;
      }, 750);
      setTimeout(function () {
        return _this2.nextStepActive = false;
      }, 750);
      setTimeout(function () {
        return _this2.progressBackReverse = false;
      }, 750);
      setTimeout(function () {
        return _this2.progressBackAnimation = false;
      }, 750);

      // Animation.
      if (switchScreen) {
        this.leftFadeOut = false;
        this.leftFadeIn = true;
        this.rightFadeIn = false;
        this.rightFadeOut = true;
      }
    },
    switchScreenReset: function switchScreenReset() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.leftFadeOut = false;
      this.leftFadeIn = false;
      this.rightFadeIn = false;
      this.rightFadeOut = false;
    },
    noJob: function noJob() {
      this.unemployed = true;
    },
    mouseOver: function mouseOver(key, opinion) {
      this.hoverActive = true;
      this.hideChecked = true;
      this.opinions = [];
      this.$set(this.opinions, key, opinion);
    },
    mouseLeave: function mouseLeave() {
      this.hoverActive = false;
      this.hideChecked = false;
      this.opinions = [];
    },
    mouseClick: function mouseClick(key, checked) {
      this.checked = [];
      this.$set(this.checked, key, checked);
    },
    submitData: function submitData() {
      users.doc(this.uid).set({
        province: this.province,
        age_category: this.age_category,
        gender: this.gender,
        highest_education: this.highest_education,
        job: this.job,
        functional_level: this.functional_level,
        sector: this.sector,
        happiness: this.happiness,
        happiness_job: this.happiness_job,
        answers: {
          part: this.part,
          important: this.important,
          friends: this.friends,
          understand: this.understand,
          control: this.control,
          performance: this.performance,
          doing_well: this.doing_well,
          hardest_tasks: this.hardest_tasks,
          expression: this.expression,
          myself: this.myself,
          want: this.want,
          best: this.best,
          meaning: this.meaning,
          matters: this.matters,
          contribute: this.contribute,
          society: this.society
        },
        name: this.name,
        email: this.email,
        email_return: this.email_return,
        newsletter: this.newsletter
      }).then(function () {
        console.log("User document written");
      }).catch(function (error) {
        console.error("Error adding user document: ", error);
      });
    },
    submitGrade: function submitGrade() {
      users.doc(this.uid).update({
        grade: this.grade
      }).then(function () {
        console.log("User document updated");
      }).catch(function (error) {
        console.error("Error updating user document: ", error);
      });
    },
    finishUp: function finishUp() {
      var _this3 = this;

      this.submitData();
      if (this.$route.query.grade == undefined) {
        this.getGrade();
      }
      this.nextStep();
      setTimeout(function () {
        return _this3.submitGrade();
      }, 2000);
    },
    submitCredentials: function submitCredentials() {
      var _this4 = this;

      users.doc(this.uid).update({
        name: this.name,
        email: this.email,
        newsletter: this.newsletter
      }).then(function () {
        if (_this4.newsletter) {
          fetch('https://mailing.driessengroep.nl/x/plugin/?pName=script_subscribe&MIDRID=S7Y1NwQAA03&pLang=nl&Z=817041111&email=' + _this4.email, { mode: 'no-cors' }).then(function (response) {
            console.log("Subscription request sent");
          }).catch(function (error) {
            console.error("Error sending subscription request: ", error);
          });
        }
        console.log("User document updated");
      }).catch(function (error) {
        console.error("Error updating user document: ", error);
      });
      this.success = true;
    },
    checkForm: function checkForm() {
      if (this.email) {
        if (!this.validEmail(this.email)) {
          this.errorActive = true;
        }
        if (!this.errorActive) {
          this.submitCredentials();
          return true;
        }
      }
    },
    removeError: function removeError() {
      this.errorActive = false;
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    toggleBodyClass: function toggleBodyClass(addRemoveClass, className) {
      var el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    alertOnLeave: function alertOnLeave() {
      window.onbeforeunload = function (e) {
        e.preventDefault();
        return 'Weet je zeker dat je de test af wilt sluiten?';
      };
    }
  },
  mounted: function mounted() {
    if (this.$route.query.email !== undefined) {
      this.email_return = this.$route.query.email;
    }
    this.debug();
    var querySet = false;
    if (this.$route.query.fill !== undefined || this.$route.query.step !== undefined || this.$route.query.grade !== undefined) {
      querySet = true;
    }
    if (querySet === false) {
      this.alertOnLeave();
    }
    this.toggleBodyClass('addClass', 'quiz');
  },
  destroyed: function destroyed() {
    this.toggleBodyClass('removeClass', 'quiz');
  }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_firebaseInit__ = __webpack_require__(37);


// A reference to the users collection.
var users = __WEBPACK_IMPORTED_MODULE_0__components_firebaseInit__["a" /* default */].collection('users');

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getGrade: function getGrade() {
      var _this = this;

      var docRef = users.doc(this.uid);
      docRef.get().then(function (documentSnapshot) {
        if (documentSnapshot.exists) {
          var data = documentSnapshot.data();
          var answerValues = [];
          // Loop through answers and push values to new array.
          for (var answer in data.answers) {
            if (data.answers.hasOwnProperty(answer)) {
              answerValues.push(data.answers[answer]);
            }
          }
          var sum = 0;
          // Loop through values and get the total sum.
          for (var i = 0; i < answerValues.length; i++) {
            sum += parseInt(answerValues[i]);
          }

          // Check for invalid sum first.
          if (typeof sum !== 'number' || sum < 0 || sum > 80) {
            console.log("Invalid sum");
          }

          // Relate sum to a grade.
          var grade = "";

          if (sum <= 16) {
            // Set grade to 1 when total is 16 or below.
            grade = 1;
          } else {
            // Multiply to get unrounded grade.
            grade = sum * 0.15625;
            // Round up grade to one decimal.
            grade = Math.round(grade * 10) / 10;
          }

          _this.grade = grade;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    }
  }
});

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cookies_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9c3461_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cookies_vue__ = __webpack_require__(226);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cookies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9c3461_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cookies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cookies',
  data: function data() {
    return {};
  },

  methods: {
    toggleBodyClass: function toggleBodyClass(addRemoveClass, className) {
      var el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted: function mounted() {
    this.toggleBodyClass('addClass', 'cookies');
  },
  destroyed: function destroyed() {
    this.toggleBodyClass('removeClass', 'cookies');
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralConditions_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5823a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralConditions_vue__ = __webpack_require__(227);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b5823a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GeneralConditions',
  data: function data() {
    return {};
  },

  methods: {
    toggleBodyClass: function toggleBodyClass(addRemoveClass, className) {
      var el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted: function mounted() {
    this.toggleBodyClass('addClass', 'general-conditions');
  },
  destroyed: function destroyed() {
    this.toggleBodyClass('removeClass', 'general-conditions');
  }
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue__ = __webpack_require__(120);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxSingle',
    props: {
        // Media source, it could be an image or a youtube video.
        'src': {
            type: String,
            required: true
        },
        // Should be video autoplayed.
        'autoplay': {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        // Short description below image.
        'description': String
    },
    data: function data() {
        return {
            overlayVisibility: false,
            embedUrl: undefined,
            items: {
                total: 0,
                position: 0
            }
        };
    },

    components: {
        'silentbox-overlay': __WEBPACK_IMPORTED_MODULE_0__overlay_vue__["a" /* default */]
    },
    methods: {
        closeSilentBoxOverlay: function closeSilentBoxOverlay() {
            this.overlayVisibility = false;
        },
        openSilentBoxOverlay: function openSilentBoxOverlay() {
            if (this.src !== null) {
                this.embedUrl = this.src;
            }
            this.overlayVisibility = true;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$on('closeSilentboxOverlay', function () {
            _this.overlayVisibility = false;
        });

        window.addEventListener('keyup', function (event) {
            if (event.which == 27) {
                _this.overlayVisibility = false;
            }
        });
    }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_overlay_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_60251c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_overlay_vue__ = __webpack_require__(235);
function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_overlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_60251c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxOverlay',
    data: function data() {
        return {
            video: false
        };
    },

    computed: {
        getEmbedUrl: function getEmbedUrl() {
            return this.handleUrl(this.$parent.embedUrl);
        },
        isVisible: function isVisible() {
            if (this.$parent.overlayVisibility !== undefined && this.$parent.overlayVisibility !== false) {
                return true;
            }

            return false;
        }
    },
    methods: {
        moveToNextItem: function moveToNextItem() {
            this.$parent.nextItem();
        },
        moveToPreviousItem: function moveToPreviousItem() {
            this.$parent.prevItem();
        },
        closeSilentboxOverlay: function closeSilentboxOverlay() {
            this.$parent.$emit('closeSilentboxOverlay');
        },
        handleUrl: function handleUrl(url) {
            if (url.includes('youtube.com')) {
                this.video = true;

                var videoIdPosition = url.indexOf('v=') + 2;
                var videoId = url.substring(videoIdPosition);

                var videoUrl = 'https://www.youtube.com/embed/' + videoId;

                if (this.$parent.autoplay) {
                    videoUrl += '?autoplay=1';
                }

                return videoUrl;
            } else {
                this.video = false;

                return url;
            }
        }
    },
    beforeUpdate: function beforeUpdate() {
        var body = document.body;

        // add class only if overlay should be visible
        if (this.isVisible && !body.classList.contains('silentbox-is-opened')) {
            return body.classList.add('silentbox-is-opened');
        }

        // remove class only if overlay should be hidden
        if (!this.isVisible && body.classList.contains('silentbox-is-opened')) {
            return body.classList.remove('silentbox-is-opened');
        }
    }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue__ = __webpack_require__(120);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxGroup',
    data: function data() {
        return {
            overlayVisibility: false,
            embedUrl: '',
            items: {
                total: 0,
                position: 0,
                list: []
            },
            autoplay: false,
            description: ''
        };
    },

    watch: {
        /**
         * Update total number of items when object changes.
         *
         * @param  {Object} current
         * @param  {Object} old
         * @return {void}
         */
        'items.list': function itemsList(current, old) {
            this.updateTotal(current);
        }
    },
    methods: {
        /**
         * Update count of total items in group.
         *
         * @param  {object} items
         * @return {void}
         */
        updateTotal: function updateTotal(items) {
            this.items.total = this.items.list.length;
        },

        /**
         * Move to next item in a group.
         *
         * @return {void}
         */
        nextItem: function nextItem() {
            if (this.items.position !== this.items.total - 1) {
                this.items.position++;
            } else {
                this.items.position = 0;
            }

            this.embedUrl = this.items.list[this.items.position].src;

            this.autoplay = this.items.list[this.items.position].autoplay !== undefined ? this.items.list[this.items.position].autoplay : false;

            this.description = this.items.list[this.items.position].desc !== undefined ? this.items.list[this.items.position].desc : false;
        },

        /**
         * Move to previous item in a group.
         *
         * @return {void}
         */
        prevItem: function prevItem() {
            if (this.items.position !== 0) {
                this.items.position--;
            } else {
                this.items.position = this.items.total - 1;
            }

            this.embedUrl = this.items.list[this.items.position].src;

            this.autoplay = this.items.list[this.items.position].autoplay !== undefined ? this.items.list[this.items.position] : false;

            this.description = this.items.list[this.items.position].desc !== undefined ? this.items.list[this.items.position].desc : false;
        },

        /**
         * Set item that shuld be displayed.
         *
         * @return {void}
         */
        setOpened: function setOpened(item) {
            this.embedUrl = item.url;
            this.items.position = item.position;
            this.overlayVisibility = true;
            this.autoplay = item.autoplay;
            this.description = item.description;
        }
    },
    components: {
        'silentbox-overlay': __WEBPACK_IMPORTED_MODULE_0__overlay_vue__["a" /* default */]
    },
    mounted: function mounted() {
        var _this = this;

        // Hide overlay when user click outside or on close button.
        this.$on('closeSilentboxOverlay', function () {
            _this.overlayVisibility = false;
        });

        // Set first opened item when overlay opens.
        this.$on('openSilentboxOverlay', function (item) {
            _this.setOpened(item);
        });

        // Update total number of available items in group.
        this.updateTotal(this.items);

        // Listen to key events.
        window.addEventListener('keyup', function (event) {
            // Escape: 27
            if (event.which === 27) {
                _this.overlayVisibility = false;
            }
            // Right arrow: 39
            if (event.which === 39) {
                _this.nextItem();
            }
            // Left arrow: 37
            if (event.which === 37) {
                _this.prevItem();
            }
        });
    }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SilentboxItem',
    props: {
        // Media source, it could be an image or a youtube video.
        'src': {
            type: String,
            required: true
        },
        // True if video should be autoplayed.
        'autoplay': {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        // Short description below image.
        'description': String,
        'position': {}
    },
    computed: {
        /**
         * Get embed URL.
         * @return {string|null}
         */
        embedUrl: function embedUrl() {
            if (this.src !== null) {
                return this.src;
            }

            return null;
        }
    },
    methods: {
        /**
         * Emit an event that overlay should be hidden.
         *
         * @return {void}
         */
        closeSilentBoxOverlay: function closeSilentBoxOverlay() {
            this.$parent.$emit('closeSilentboxOverlay');
        },

        /**
         * Emit an event that overlay should be opened.
         *
         * @return {void}
         */
        openSilentBoxOverlay: function openSilentBoxOverlay() {
            var _this = this;

            var itemIndex = this.$parent.items.list.findIndex(function (item) {
                return item.src === _this.src;
            });

            this.$parent.$emit('openSilentboxOverlay', {
                url: this.embedUrl,
                position: itemIndex,
                autoplay: this.autoplay,
                description: this.description
            });
        }
    },
    created: function created() {
        // Push items to the parent component.
        // TODO: do it in parent component
        this.$parent.items.list.push({
            src: this.src,
            autoplay: this.autoplay,
            desc: this.description,
            position: this.position
        });
    }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getGrade_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_firebaseInit__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// A reference to the users collection.
var users = __WEBPACK_IMPORTED_MODULE_2__components_firebaseInit__["a" /* default */].collection('users');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Results',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getGrade_js__["a" /* default */]],
  data: function data() {
    return {
      grade: null,
      ownGrade: null,
      uid: this.$route.params.uid,
      tipActive: '#tip-1',
      tipTitleSolidarity: null,
      tipSolidarity: null,
      tipLinkTextSolidarity: null,
      tipTitleCompetence: null,
      tipCompetence: null,
      tipLinkTextCompetence: null,
      tipTitleAutonomy: null,
      tipAutonomy: null,
      tipLinkTextAutonomy: null,
      tipTitleSocial: null,
      tipSocial: null,
      tipLinkTextSocial: null
    };
  },

  computed: {
    classResults: function classResults() {
      return {
        'results-color--red': this.grade < 6,
        'results-color--orange': this.grade >= 6 && this.grade < 7,
        'results-color--green': this.grade >= 7
      };
    },
    emotionsResults: function emotionsResults() {
      return {
        'emoticon--totally-agree': this.grade > 8,
        'emoticon--agree': this.grade >= 6 && this.grade <= 8,
        'emoticon--neutral': this.grade >= 5 && this.grade < 6,
        'emoticon--disagree': this.grade >= 3 && this.grade < 5,
        'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3
      };
    }
  },
  methods: {
    getOwnGrade: function getOwnGrade() {
      var _this = this;

      var docRef = users.doc(this.uid);
      docRef.get().then(function (documentSnapshot) {
        if (documentSnapshot.exists) {
          var data = documentSnapshot.data();
          _this.ownGrade = data.happiness_job;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    smoothScroll: function smoothScroll() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('a[href^="#"]')).forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();

          document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
          });
        });
      });
    },
    onScroll: function onScroll() {
      var tip = document.querySelectorAll(".tip");
      var tips = {};
      var i = 0;

      Array.prototype.forEach.call(tip, function (e) {
        tips[e.id] = e.offsetTop;
      });

      var scrolledDiv = document.querySelector(".right");

      scrolledDiv.onscroll = function () {
        var scrollPosition = scrolledDiv.scrollTop;

        for (i in tips) {
          if (tips[i] <= scrollPosition) {
            document.querySelector('.active').setAttribute('class', ' ');
            document.querySelector('a[href*=' + i + ']').setAttribute('class', 'active');
          }
        }
      };
    },
    mouseClick: function mouseClick(tipId) {
      var _this2 = this;

      setTimeout(function () {
        return _this2.tipActive = tipId;
      }, 750);
    },
    getSumPerChapter: function getSumPerChapter() {
      var _this3 = this;

      var docRef = users.doc(this.uid);
      docRef.get().then(function (documentSnapshot) {
        if (documentSnapshot.exists) {
          var data = documentSnapshot.data();
          // Solidarity.
          var part = eval(data.answers.part);
          var important = eval(data.answers.important);
          var friends = eval(data.answers.friends);
          var understand = eval(data.answers.understand);
          var sumSolidarity = part + important + friends + understand;
          // Competence.
          var control = eval(data.answers.control);
          var performance = eval(data.answers.performance);
          var doing_well = eval(data.answers.doing_well);
          var hardest_tasks = eval(data.answers.hardest_tasks);
          var sumCompetence = control + performance + doing_well + hardest_tasks;
          // Autonomy.
          var expression = eval(data.answers.expression);
          var myself = eval(data.answers.myself);
          var want = eval(data.answers.want);
          var best = eval(data.answers.best);
          var sumAutonomy = expression + myself + want + best;
          // Social.
          var meaning = eval(data.answers.meaning);
          var matters = eval(data.answers.matters);
          var contribute = eval(data.answers.contribute);
          var society = eval(data.answers.society);
          var sumSocial = meaning + matters + contribute + society;

          // Check for invalid sum first.
          if (typeof sumSolidarity !== 'number' || sumSolidarity < 0 || sumSolidarity > 80) {
            console.log("Invalid sum");
          }
          if (typeof sumCompetence !== 'number' || sumCompetence < 0 || sumCompetence > 80) {
            console.log("Invalid sum");
          }
          if (typeof sumAutonomy !== 'number' || sumAutonomy < 0 || sumAutonomy > 80) {
            console.log("Invalid sum");
          }
          if (typeof sumSocial !== 'number' || sumSocial < 0 || sumSocial > 80) {
            console.log("Invalid sum");
          }

          // Relate sum to a tip.
          var tipTitleSolidarity = "";
          var tipSolidarity = "";
          var tipLinkTextSolidarity = "";

          switch (true) {
            // 0 - 5.
            case sumSolidarity <= 5:
              tipTitleSolidarity = 'Collega’s, je bent ze liever kwijt dan rijk';
              tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor jij laag. Oei, jouw collega’s zijn duidelijk niet je beste vrienden. Misschien ligt het eraan dat het gewoon niet jouw type mensen zijn, misschien erger je je dagelijks groen en geel of misschien ben je gewoon tevreden met de situatie zoals die is. Toch draagt verbondenheid met de organisatie waar je werkt en je collega’s bij aan jouw werkgeluk. Om nu meteen beste vrienden te worden met je collega’s is misschien wat overdreven, maar investeren in de relatie met je collega’s brengt zeker voordelen met zich mee voor jouw werkgeluk.';
              tipLinkTextSolidarity = 'In dit <a href="https://www.driessen.nl/samenslim/mentaal-vitaal-door-steun-van-collegas?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> lees je meer over wat een goede band met collega’s jou kan opleveren.';
              break;
            // 6 - 10.
            case sumSolidarity <= 10:
              tipTitleSolidarity = 'Beter een verre vriend dan een goede collega?';
              tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor jij gemiddeld. De band met je collega’s kan wel wat verbetering gebruiken. Misschien zijn het niet jouw soort mensen of erger je je soms groen en geel aan iemand? Verbondenheid met de organisatie waar je werkt en de directe collega’s om je heen dragen bij aan werkgeluk. Belangrijk dus om de band te verstevigen. Een groot deel van de dag beleef je tenslotte op het werk, waardoor je je collega’s misschien zelfs nog wel meer ziet dan je eigen partner en vrienden.';
              tipLinkTextSolidarity = 'In dit <a href="https://www.driessen.nl/samenslim/beter-een-goede-collega-dan-een-verre-vriend?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> vind je tips om de band met je collega’s te versterken en eventuele (kleine) irritaties aan de kant te zetten.';
              break;
            // 11 - 16.
            case sumSolidarity <= 16:
              tipTitleSolidarity = 'Collega’s? Voor jou zijn het vrienden';
              tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor je hoog. Bij jouw collega’s ben je helemaal op je plek en kun je helemaal jezelf zijn. Een hoge verbondenheid met de organisatie waar je werkt en de directe collega’s om je heen, dragen bij aan jouw werkgeluk. Belangrijk dus om de band met je collega’s goed te houden. Een groot deel van de dag beleef je tenslotte met hun. Je ziet ze misschien zelfs nog wel meer dan je eigen partner, gezin en/of vrienden.';
              tipLinkTextSolidarity = 'Doe <a href="https://www.driessen.nl/samenslim/de-10-collegas-die-je-niet-kunt-missen?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> de ‘Collega’s die je niet kunt missen’-BINGO.';
              break;
          }

          _this3.tipTitleSolidarity = tipTitleSolidarity;
          _this3.tipSolidarity = tipSolidarity;
          _this3.tipLinkTextSolidarity = tipLinkTextSolidarity;

          // Relate sum to a tip.
          var tipTitleCompetence = "";
          var tipCompetence = "";
          var tipLinkTextCompetence = "";

          console.log(sumCompetence);

          switch (true) {
            // 0 - 5.
            case sumCompetence <= 5:
              tipTitleCompetence = 'Help, de sleur slaat toe';
              tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je laag. Dit vraagt om aandacht. Je werkgeluk wordt voor een groot deel bepaald door hoe jij je kwaliteiten in je werk kunt benutten. Helemaal op je plek zit je dus waarschijnlijk niet (meer) in je huidige functie. Onderzoek waar jouw talenten en drijfveren liggen, maak het bespreekbaar bij je leidinggevende en onderneem actie. Het wordt tijd dat jij weer plezier krijgt in je werk!';
              tipLinkTextCompetence = 'Lees <a href="https://www.driessen.nl/samenslim/wat-als-de-sleur-toeslaat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over hoe je de sleur in je werk kunt aanpakken.';
              break;
            // 6 - 10.
            case sumCompetence <= 10:
              tipTitleCompetence = 'Het glas is half vol';
              tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je gemiddeld. Jij en je werk hebben af en toe een haat-liefdeverhouding. Het ene moment kun je er je ei helemaal in kwijt, het andere moment ben je aan het worstelen met dat wat je moet doen. Probeer je weg te vinden, praat met je leidinggevende over wat je leuk vindt om te doen en waar je moeite mee hebt en achterhaal wat jouw drijfveren zijn. Want het benutten van je talent en competenties in je werk draagt bij aan jouw werkgeluk.';
              tipLinkTextCompetence = 'Wat zou het toch gaaf zijn als je heel de dag kon doen wat je leuk vindt, het kan! Lees <a href="https://www.driessen.nl/samenslim/als-doet-leuk-vindt-hoef-nooit-meer-werken?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer.';
              break;
            // 11 - 16.
            case sumCompetence <= 16:
              tipTitleCompetence = 'Jij bent de beste versie van jezelf in jouw werk!';
              tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je hoog. In jouw werk ben je helemaal in je element. Je kunt er je kwaliteiten in kwijt en schittert van zelfvertrouwen. Kortom, jouw functie is voor jou gemaakt. Je talenten kwijt kunnen in je werk draagt in hoge mate bij aan het ervaren van werkgeluk. Ga dus vooral zo door, maar blijf jezelf wel ontwikkelen en ga uitdagingen aan, want een baan voor het leven bestaat niet meer.';
              tipLinkTextCompetence = 'In dit <a href="https://www.driessen.nl/samenslim/over-10-jaar?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> meer over hoe jij je kunt voorbereiden op de toekomst.';
              break;
          }

          _this3.tipTitleCompetence = tipTitleCompetence;
          _this3.tipCompetence = tipCompetence;
          _this3.tipLinkTextCompetence = tipLinkTextCompetence;

          // Relate sum to a tip.
          var tipTitleAutonomy = "";
          var tipAutonomy = "";
          var tipLinkTextAutonomy = "";

          switch (true) {
            // 0 - 5.
            case sumAutonomy <= 5:
              tipTitleAutonomy = 'Neem de regie in eigen hand';
              tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je laag. Je voelt je beperkt in je doen en laten binnen je functie en ervaart niet de vrijheid om je mening te geven of je ideeën op tafel te gooien. Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger. Is er binnen jouw functie geen ruimte voor deze vrijheid en heb je hier wel behoefte aan? Ga het gesprek dan aan met je leidinggevende en kijk samen naar mogelijkheden binnen of desnoods buiten de organisatie om deze vrijheid alsnog te vinden.';
              tipLinkTextAutonomy = 'Vind je het moeilijk om het gesprek aan te gaan met je leidinggevende? Lees <a href="https://www.driessen.nl/samenslim/een-moeilijk-gesprek-aangaan-hoe-doe-je-dat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> hoe je dit het beste kunt aanpakken.';
              break;
            // 6 - 10.
            case sumAutonomy <= 10:
              tipTitleAutonomy = 'Wat houdt je tegen?';
              tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je gemiddeld. Binnen bepaalde kaders voel je de vrijheid om je werk naar eigen inzicht in te vullen en je ideeën en bevindingen te delen met de organisatie. Toch houdt iets je tegen om helemaal jezelf te zijn en je eigen draai te geven aan je functie. Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger. Maak het bespreekbaar bij je leidinggevende en kijk samen naar de ruimte die er is en eventueel nog genomen kan worden.';
              tipLinkTextAutonomy = 'Vind je het moeilijk om dit gesprek aan te gaan? Lees <a href="https://www.driessen.nl/samenslim/een-moeilijk-gesprek-aangaan-hoe-doe-je-dat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> hoe je dit het beste kunt aanpakken.';
              break;
            // 11 - 16.
            case sumAutonomy <= 16:
              tipTitleAutonomy = 'Zo vrij als een vogel';
              tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je hoog. In jouw werk krijg jij alle vrijheid om te doen wat je leuk vindt en waar je goed in bent. Daarnaast voel je alle vrijheid om je ideeën op tafel te gooien. Kortom, jij kunt helemaal jezelf zijn. Heel goed! Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger.';
              tipLinkTextAutonomy = 'Lees <a href="https://www.driessen.nl/samenslim/autonomie-als-basis-van-werkgeluk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over het positieve effect van autonomie op werkgeluk.';
              break;
          }

          _this3.tipTitleAutonomy = tipTitleAutonomy;
          _this3.tipAutonomy = tipAutonomy;
          _this3.tipLinkTextAutonomy = tipLinkTextAutonomy;

          // Relate sum to a tip.
          var tipTitleSocial = "";
          var tipSocial = "";
          var tipLinkTextSocial = "";

          switch (true) {
            // 0 - 5.
            case sumSocial <= 5:
              tipTitleSocial = 'Ben je niet betekenisvol? Of denk je het niet te zijn?';
              tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je laag. Dat wil zeggen dat jij jouw werk niet als betekenisvol ervaart. Maar is het dat ook echt niet? Of zie jij alleen niet hoe betekenisvol jij bent? Wil je dit veranderen? Ontplooi dan binnen je werk maatschappelijk relevante initiatieven en activiteiten. Denk bijvoorbeeld aan het bijdragen aan een goed doel met je collega’s, het opknappen van een speeltuin als gezamenlijk teamuitje of het inzetten van je ervaring voor goede doelen of maatschappelijk werk, eventueel naast je reguliere baan. Je zult zien dat jij binnen de kortste keren meer werkgeluk ervaart.';
              tipLinkTextSocial = 'Lees <a href="https://www.driessen.nl/samenslim/werken-aan-betekenisvol-werk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer hoe jij je werk betekenisvoller kan maken.';
              break;
            // 6 - 10.
            case sumSocial <= 10:
              tipTitleSocial = 'Go for it!';
              tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je gemiddeld. Niet bij iedere functie is de maatschappelijke relevantie even goed tastbaar, maar wat je werk ook is, je bent altijd betekenisvol! Om meer betekenis te ervaren in je werk, is het belangrijk om je eigen professionele missie te bepalen. Dit is jouw leidraad in je werk. Het maakt duidelijk wie je bent, wat je wilt en waartoe je met je werk wilt bijdragen. Daarnaast geeft het antwoord op de vraag waarom je doet wat je doet in je werk.';
              tipLinkTextSocial = 'Lees <a href="https://www.driessen.nl/samenslim/werken-aan-betekenisvol-werk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over hoe jij je werk betekenisvoller kan maken.';
              break;
            // 11 - 16.
            case sumSocial <= 16:
              tipTitleSocial = 'Jij bent onmisbaar';
              tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je hoog. Met jouw werk lever jij een onmisbare bijdrage aan de organisatie en/of de maatschappij. Kortom, jij bent betekenisvol! Werk dat als betekenisvol ervaren wordt, draagt bij aan positieve gevoelens als zelfvertrouwen, optimisme, hoop en werkgeluk. Dus blijf vooral doen waar je mee bezig bent en sta regelmatig even stil bij al het moois dat jij met jouw werk brengt.';
              tipLinkTextSocial = 'Benieuwd naar betekenisvolle beroepen? Lees <a href="https://www.driessen.nl/samenslim/heb-jij-een-betekenisvol-beroep?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer.';
              break;
          }

          _this3.tipTitleSocial = tipTitleSocial;
          _this3.tipSocial = tipSocial;
          _this3.tipLinkTextSocial = tipLinkTextSocial;
        }
      });
    },
    toggleBodyClass: function toggleBodyClass(addRemoveClass, className) {
      var el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted: function mounted() {
    this.toggleBodyClass('addClass', 'results');
    this.onScroll();
  },
  destroyed: function destroyed() {
    this.toggleBodyClass('removeClass', 'results');
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_tracing__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dist_css_style_css__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_dist_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_dist_css_style_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__sentry_vue__["a" /* init */]({
  Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */],
  dsn: "https://79e0ccf572de4cbbabb0b19a95140ad1@o243225.ingest.sentry.io/6618216",
  integrations: [new __WEBPACK_IMPORTED_MODULE_4__sentry_tracing__["a" /* BrowserTracing */]({
    routingInstrumentation: __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["b" /* vueRouterInstrumentation */](__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]),
    tracingOrigins: ["localhost", "acc-www.testjewerkgeluk.nl", "www.testjewerkgeluk.nl", /^\//]
  })],
  tracesSampleRate: 1.0
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  logErrors: true,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
}).$mount("#app");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31023a21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(228);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31023a21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"content"},[_c('header',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row-inner row-svg"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"pre-title"},[_vm._v("\n            Test je\n          ")]),_vm._v(" "),_c('svg',{staticClass:"main-title",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2153","height":"609","viewBox":"0 0 2153 609"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"10","transform":"translate(5 5)"}},[_c('path',{staticClass:"path-1",attrs:{"stroke":"#B71234","d":"M45.5510805,302.556445 C-86.4489195,529.112891 81.5510805,758 380.55108,447 C468.287251,355.742645 529.55108,336.939549 591.773796,336.939549 C582.148772,368.490209 568.317077,414.345577 583.192114,412.597483 C598.067151,410.849388 617.317199,378.852496 625.192219,355.130724 C620.812935,386.211554 620.812935,401.894883 627.817225,401.26755 C652.441041,399.062139 666.688516,353.271264 674.192341,325.80758 C686.831126,337.452981 704.096221,341.474422 725.354233,334.294428 C728.854241,319.59567 743.612213,286.626263 756.854311,285.440246 C777.330558,283.606308 758.604316,321.726224 725.354233,334.294428 C720.10422,355.863055 730.073798,372.005535 748.218131,370.380453 C766.362463,368.755371 802.354424,334.111103 825.104481,285.08159 C835.604507,300.444484 843.479527,301.657203 854.854555,302.556445 C825.104481,343.603294 840.298637,354.746074 856.60456,349.391631 C874.787376,343.420863 924.190454,287.941259 927.583283,272.959757 C932.628423,250.682245 938.134174,224.76128 944.937997,194.849823 L912.562917,339.684258 C916.062926,323.387135 918.979599,310.019315 921.312939,299.580797 C927.312418,272.741288 959.813034,231.878307 973.813069,244.050669 C978.297849,247.949971 966.813052,278.243279 948.438006,281.807062 C948.438006,298.110382 951.938015,324.649434 968.563056,323.160426 C985.188098,321.671419 1022.39234,274.009752 1036.39238,255.493512 C1050.39241,236.977271 1070.51746,215.035393 1090.64251,224.741136 C1078.39248,256.526902 1059.14243,304.28392 1038.14238,306.164772 C1024.14235,307.418674 1017.74545,284.263868 1036.39238,255.493512 C1017.74545,284.263868 1024.14235,307.418674 1038.14238,306.164772 C1067.01745,303.578601 1094.93335,211.520742 1089.68334,227.335256 C1084.43333,243.149771 1075.29576,287.633679 1071.45907,304.671842 C1067.62239,321.710006 1061.34861,365.09235 1042.38054,366.791209 C1029.83058,367.915235 1031.88051,352.048305 1034.50552,345.100067 C1047.98103,309.431176 1114.62181,290.916205 1139.92845,244.001867 C1146.92847,217.097936 1160.9285,192.252035 1178.42854,194.520734 C1195.92859,196.789433 1165.30351,247.483284 1139.92845,244.001867 C1135.55344,262.68154 1148.74871,281.211032 1164.49875,279.800393 C1222.14892,274.637005 1279.13796,150.817672 1279.13796,120.330426 C1279.13796,96.7445565 1235.21952,128.014167 1235.21952,212.407824 C1235.21952,245.066911 1249.12509,252.386487 1261.37512,251.289323 C1291.94321,248.551518 1328.89772,197.046924 1338.58725,153.85348 C1332.5464,178.412921 1310.80638,235.539241 1337.05645,233.188176 C1363.30651,230.837111 1389.90416,143.10943 1389.90416,143.10943 C1389.90416,143.10943 1363.93385,224.885382 1390.34741,218.782101 C1416.76097,212.678819 1450.55422,160.55784 1455.80423,150.497438 C1458.72091,138.727983 1465.42926,109.676263 1475.92928,63.3422788 L1441.8042,210.251488 C1456.38757,146.92879 1475.34595,114.222523 1498.67934,112.132687 C1518.65742,110.343368 1489.05432,150.396479 1478.55429,151.336905 C1478.55429,164.763169 1483.14991,193.503627 1507.88231,192.395361 C1539.83472,190.963565 1575.40592,165.910051 1619.14625,122.09328 C1687.24746,53.8730544 1770.06287,5.40198123 1899.55108,13.984862 C2029.03929,22.5677428 2100.55108,68.6608519 2142.55108,120.330426","opacity":".5"}}),_vm._v(" "),_c('path',{staticClass:"path-2",attrs:{"stroke":"#FFF","d":"M45.5510805,289.556445 C-86.4489195,516.112891 81.5510805,745 380.55108,434 C468.287251,342.742645 529.55108,323.939549 591.773796,323.939549 C582.148772,355.490209 568.317077,401.345577 583.192114,399.597483 C598.067151,397.849388 617.317199,365.852496 625.192219,342.130724 C620.812935,373.211554 620.812935,388.894883 627.817225,388.26755 C652.441041,386.062139 666.688516,340.271264 674.192341,312.80758 C686.831126,324.452981 704.096221,328.474422 725.354233,321.294428 C728.854241,306.59567 743.612213,273.626263 756.854311,272.440246 C777.330558,270.606308 758.604316,308.726224 725.354233,321.294428 C720.10422,342.863055 730.073798,359.005535 748.218131,357.380453 C766.362463,355.755371 802.354424,321.111103 825.104481,272.08159 C835.604507,287.444484 843.479527,288.657203 854.854555,289.556445 C825.104481,330.603294 840.298637,341.746074 856.60456,336.391631 C874.787376,330.420863 924.190454,274.941259 927.583283,259.959757 C932.628423,237.682245 938.134174,211.76128 944.937997,181.849823 L912.562917,326.684258 C916.062926,310.387135 918.979599,297.019315 921.312939,286.580797 C927.312418,259.741288 959.813034,218.878307 973.813069,231.050669 C978.297849,234.949971 966.813052,265.243279 948.438006,268.807062 C948.438006,285.110382 951.938015,311.649434 968.563056,310.160426 C985.188098,308.671419 1022.39234,261.009752 1036.39238,242.493512 C1050.39241,223.977271 1070.51746,202.035393 1090.64251,211.741136 C1078.39248,243.526902 1059.14243,291.28392 1038.14238,293.164772 C1024.14235,294.418674 1017.74545,271.263868 1036.39238,242.493512 C1017.74545,271.263868 1024.14235,294.418674 1038.14238,293.164772 C1067.01745,290.578601 1094.93335,198.520742 1089.68334,214.335256 C1084.43333,230.149771 1075.29576,274.633679 1071.45907,291.671842 C1067.62239,308.710006 1061.34861,352.09235 1042.38054,353.791209 C1029.83058,354.915235 1031.88051,339.048305 1034.50552,332.100067 C1047.98103,296.431176 1114.62181,277.916205 1139.92845,231.001867 C1146.92847,204.097936 1160.9285,179.252035 1178.42854,181.520734 C1195.92859,183.789433 1165.30351,234.483284 1139.92845,231.001867 C1135.55344,249.68154 1148.74871,268.211032 1164.49875,266.800393 C1222.14892,261.637005 1279.13796,137.817672 1279.13796,107.330426 C1279.13796,83.7445565 1235.21952,115.014167 1235.21952,199.407824 C1235.21952,232.066911 1249.12509,239.386487 1261.37512,238.289323 C1291.94321,235.551518 1328.89772,184.046924 1338.58725,140.85348 C1332.5464,165.412921 1310.80638,222.539241 1337.05645,220.188176 C1363.30651,217.837111 1389.90416,130.10943 1389.90416,130.10943 C1389.90416,130.10943 1363.93385,211.885382 1390.34741,205.782101 C1416.76097,199.678819 1450.55422,147.55784 1455.80423,137.497438 C1458.72091,125.727983 1465.42926,96.6762629 1475.92928,50.3422788 L1441.8042,197.251488 C1456.38757,133.92879 1475.34595,101.222523 1498.67934,99.1326874 C1518.65742,97.3433678 1489.05432,137.396479 1478.55429,138.336905 C1478.55429,151.763169 1483.14991,180.503627 1507.88231,179.395361 C1539.83472,177.963565 1575.40592,152.910051 1619.14625,109.09328 C1687.24746,40.8730544 1770.06287,-7.59801877 1899.55108,0.98486202 C2029.03929,9.56774281 2100.55108,55.6608519 2142.55108,107.330426"}})])])])])]),_vm._v(" "),_c('main',[_c('h1',[_vm._v("Test je werkgeluk")]),_vm._v(" "),_c('div',{staticClass:"row-inner"},[_c('div',{staticClass:"content-row content-row--intro"},[_c('div',{staticClass:"heading-mobile"},[_c('h2',{staticClass:"white"},[_vm._v("Hoe werkgelukkig ben jij?")]),_vm._v(" "),_c('router-link',{staticClass:"button to-quiz",attrs:{"to":{ name: 'Quiz'}}},[_vm._v("\n              doe de test\n            ")])],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text row-item-right"},[_c('div',{staticClass:"button-container"},[_c('router-link',{staticClass:"button to-quiz",attrs:{"to":{ name: 'Quiz'}}},[_vm._v("\n                doe de test\n              ")]),_vm._v(" "),_c('span',[_vm._v("Ontdek in 2 minuten of je werkgelukkig bent")])],1),_vm._v(" "),_c('h2',{staticClass:"white"},[_vm._v("Hoe werkgelukkig ben jij?")]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("\n              Anderen gelukkig maken is de meest effectieve manier om zelf gelukkig te worden. Maar er zijn meerdere\n              factoren die je geluk beïnvloeden. Een van de dingen die veel invloed heeft op je geluk is je\n              werkgeluk.\n            ")]),_vm._v(" "),_c('h3',{staticClass:"white"},[_vm._v("De test geeft inzicht in je:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('router-link',{staticClass:"button to-quiz",attrs:{"to":{ name: 'Quiz'}}},[_vm._v("\n              doe de test\n            ")])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"content-row content-row--videos"},[_c('silentbox-group',[_c('silentbox-single',{attrs:{"src":"https://www.youtube.com/watch?v=n7rw34b8YIQ"}},[_c('div',{staticClass:"silentbox-single__image",staticStyle:{"background-image":"url('https://img.youtube.com/vi/n7rw34b8YIQ/maxresdefault.jpg')"}})]),_vm._v(" "),_c('silentbox-single',{attrs:{"src":"https://www.youtube.com/watch?v=MnFfMVr-t3k"}},[_c('div',{staticClass:"silentbox-single__image",staticStyle:{"background-image":"url('https://img.youtube.com/vi/MnFfMVr-t3k/maxresdefault.jpg')"}})]),_vm._v(" "),_c('silentbox-single',{attrs:{"src":"https://www.youtube.com/watch?v=UssMYMl_NRI"}},[_c('div',{staticClass:"silentbox-single__image",staticStyle:{"background-image":"url('https://img.youtube.com/vi/UssMYMl_NRI/maxresdefault.jpg')"}})])],1)],1),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_vm._m(5)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-inner"},[_c('img',{staticClass:"logo logo-desktop",attrs:{"src":__webpack_require__(30),"alt":"Driessen Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo logo-mobile",attrs:{"src":__webpack_require__(31),"alt":"Driessen Logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image row-item-left"},[_c('img',{attrs:{"src":__webpack_require__(211)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"white checklist"},[_c('li',[_vm._v("relatie met collega's")]),_vm._v(" "),_c('li',[_vm._v("competenties")]),_vm._v(" "),_c('li',[_vm._v("vrijheid in je werk")]),_vm._v(" "),_c('li',[_vm._v("manier van mensen gelukkig maken")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row content-row--above-video"},[_c('h2',{staticClass:"white"},[_vm._v("Geluk werkt door")]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("\n            Mensen die werken in de sectoren overheid, onderwijs, zorg en cultuur maken anderen gelukkig. En daarvoor hebben wij het bewijs. Wij verrasten leerlingcoördinator Theo, uitvoerend gebiedstoezichthouder Annelies en medewerker Publiekszaken Jacqueline met hartverwarmende reacties van\n            degenen die zij gelukkig maken.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row content-row--bottom"},[_c('div',{staticClass:"text row-item-left"},[_c('h2',{staticClass:"white"},[_vm._v("Vind je werkgeluk bij Driessen")]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("\n              Wij maken werk van je baan in de overheid, het onderwijs, de zorg of de culturele sector. Maar\n              belangrijker nog; wij maken werk van je werkgeluk. Goed om te weten is dat we dit doen bij 1.200\n              organisaties, voor ruim 15.000 talenten. Talenten die zich elke dag inzetten om anderen te helpen,\n              anderen iets te leren of voor anderen te zorgen. Talenten zoals jij. Want jij maakt met je werk de\n              wereld elke dag weer een stukje mooier. Een stukje gelukkiger.\n            ")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',[_c('a',{staticClass:"button button--margin",attrs:{"href":"https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("bekijk onze vacatures")])]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_vm._v("\n              of   "),_c('a',{staticClass:"button",attrs:{"href":"https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("schrijf je gratis in")])])]),_vm._v(" "),_c('div',{staticClass:"image row-item-right"},[_c('img',{attrs:{"src":__webpack_require__(212)}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"row-inner"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"logo-footer"},[_c('img',{staticClass:"logo-drop",attrs:{"src":__webpack_require__(57),"alt":"Driessen Logo"}})]),_vm._v(" "),_c('div',{staticClass:"social-links follow"},[_c('span',{staticClass:"label"},[_vm._v("Volg ons")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Facebook")])]),_vm._v(" "),_c('li',{staticClass:"linkedin"},[_c('a',{attrs:{"href":"https://www.linkedin.com/company/driessen-nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("LinkedIn")])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/Driessen_nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',{staticClass:"youtube"},[_c('a',{attrs:{"href":"https://www.youtube.com/user/DriessenHRM","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Whatsapp")])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Instagram")])])])]),_vm._v(" "),_c('div',{staticClass:"footer-bottom"},[_c('a',{attrs:{"target":"_blank","href":"/cookies"}},[_vm._v("Cookies")]),_vm._v("   \n            "),_c('a',{attrs:{"target":"_blank","href":"/general-conditions"}},[_vm._v("Voorwaarden")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/girl-child.a60f854.png";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boy-keyboard.cae615c.png";

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: "AIzaSyBKCjbjrRI8-fg1m8rzQI3-eQ2JS68L7ew",
  authDomain: "testjewerkgeluk.firebaseapp.com",
  databaseURL: "https://testjewerkgeluk.firebaseio.com",
  projectId: "testjewerkgeluk",
  storageBucket: "testjewerkgeluk.appspot.com",
  messagingSenderId: "808650980286"
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: "AIzaSyD-CygictQXLXNYs5XfH-X83G8WyARa6ok",
  authDomain: "test-je-werkgeluk-acc-5213b.firebaseapp.com",
  databaseURL: "https://test-je-werkgeluk-acc-5213b.firebaseio.com",
  projectId: "test-je-werkgeluk-acc-5213b",
  storageBucket: "",
  messagingSenderId: "189520909666"
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"quiz"}},[_vm._m(0),_vm._v(" "),_c('main',[_c('form',[_c('h1',[_vm._v("Test je werkgeluk")]),_vm._v(" "),(_vm.step === 1)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("In welke provincie woon je?")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation': _vm.progressActive },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Kies je provincie")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-1","value":"drenthe","name":"drenthe"},domProps:{"checked":_vm._q(_vm.province,"drenthe")},on:{"change":function($event){_vm.province="drenthe"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-1"}},[_vm._v("Drenthe")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-2","value":"gelderland","name":"gelderland"},domProps:{"checked":_vm._q(_vm.province,"gelderland")},on:{"change":function($event){_vm.province="gelderland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-2"}},[_vm._v("Gelderland")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-3","value":"groningen","name":"groningen"},domProps:{"checked":_vm._q(_vm.province,"groningen")},on:{"change":function($event){_vm.province="groningen"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-3"}},[_vm._v("Groningen")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-4","value":"flevoland","name":"flevoland"},domProps:{"checked":_vm._q(_vm.province,"flevoland")},on:{"change":function($event){_vm.province="flevoland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-4"}},[_vm._v("Flevoland")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-5","value":"friesland","name":"friesland"},domProps:{"checked":_vm._q(_vm.province,"friesland")},on:{"change":function($event){_vm.province="friesland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-5"}},[_vm._v("Friesland")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-6","value":"limburg","name":"limburg"},domProps:{"checked":_vm._q(_vm.province,"limburg")},on:{"change":function($event){_vm.province="limburg"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-6"}},[_vm._v("Limburg")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-7","value":"noord_brabant","name":"noord_brabant"},domProps:{"checked":_vm._q(_vm.province,"noord_brabant")},on:{"change":function($event){_vm.province="noord_brabant"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-7"}},[_vm._v("Noord-Brabant")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-8","value":"noord_holland","name":"noord_holland"},domProps:{"checked":_vm._q(_vm.province,"noord_holland")},on:{"change":function($event){_vm.province="noord_holland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-8"}},[_vm._v("Noord-Holland")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-9","value":"overijssel","name":"overijssel"},domProps:{"checked":_vm._q(_vm.province,"overijssel")},on:{"change":function($event){_vm.province="overijssel"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-9"}},[_vm._v("Overijssel")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-10","value":"utrecht","name":"utrecht"},domProps:{"checked":_vm._q(_vm.province,"utrecht")},on:{"change":function($event){_vm.province="utrecht"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-10"}},[_vm._v("Utrecht")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-11","value":"zeeland","name":"zeeland"},domProps:{"checked":_vm._q(_vm.province,"zeeland")},on:{"change":function($event){_vm.province="zeeland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-11"}},[_vm._v("Zeeland")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.province),expression:"province"}],attrs:{"type":"radio","id":"p-12","value":"zuid_holland","name":"zuid_holland"},domProps:{"checked":_vm._q(_vm.province,"zuid_holland")},on:{"change":function($event){_vm.province="zuid_holland"}}}),_vm._v(" "),_c('label',{attrs:{"for":"p-12"}},[_vm._v("Zuid-Holland")])])]),_vm._v(" "),(_vm.province && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-01"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Hoe oud ben je?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-2': _vm.progressActive, 'user-path-animation-set': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Kies je leeftijdscategorie")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-1","value":"<_18","name":"<_18"},domProps:{"checked":_vm._q(_vm.age_category,"<_18")},on:{"change":function($event){_vm.age_category="<_18"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-1"}},[_vm._v("< 18 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-2","value":"18_25","name":"18_25"},domProps:{"checked":_vm._q(_vm.age_category,"18_25")},on:{"change":function($event){_vm.age_category="18_25"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-2"}},[_vm._v("18 – 25 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-3","value":"26_30","name":"26_30"},domProps:{"checked":_vm._q(_vm.age_category,"26_30")},on:{"change":function($event){_vm.age_category="26_30"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-3"}},[_vm._v("26 – 30 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-4","value":"31_35","name":"31_35"},domProps:{"checked":_vm._q(_vm.age_category,"31_35")},on:{"change":function($event){_vm.age_category="31_35"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-4"}},[_vm._v("31 – 35 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-5","value":"36_40","name":"36_40"},domProps:{"checked":_vm._q(_vm.age_category,"36_40")},on:{"change":function($event){_vm.age_category="36_40"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-5"}},[_vm._v("36 – 40 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-6","value":"41_45","name":"41_45"},domProps:{"checked":_vm._q(_vm.age_category,"41_45")},on:{"change":function($event){_vm.age_category="41_45"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-6"}},[_vm._v("41 – 45 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-7","value":"46_50","name":"46_50"},domProps:{"checked":_vm._q(_vm.age_category,"46_50")},on:{"change":function($event){_vm.age_category="46_50"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-7"}},[_vm._v("46 – 50 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-8","value":"51_55","name":"51_55"},domProps:{"checked":_vm._q(_vm.age_category,"51_55")},on:{"change":function($event){_vm.age_category="51_55"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-8"}},[_vm._v("51 – 55 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-9","value":"56_60","name":"56_60"},domProps:{"checked":_vm._q(_vm.age_category,"56_60")},on:{"change":function($event){_vm.age_category="56_60"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-9"}},[_vm._v("56 – 60 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-10","value":"60_70","name":"60_70"},domProps:{"checked":_vm._q(_vm.age_category,"60_70")},on:{"change":function($event){_vm.age_category="60_70"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-10"}},[_vm._v("60 – 67 jaar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_category),expression:"age_category"}],attrs:{"type":"radio","id":"ag-11","value":">_67","name":">_67"},domProps:{"checked":_vm._q(_vm.age_category,">_67")},on:{"change":function($event){_vm.age_category=">_67"}}}),_vm._v(" "),_c('label',{attrs:{"for":"ag-11"}},[_vm._v("> 67 jaar")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.age_category && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-02"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Wat is je geslacht?")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-3': _vm.progressActive, 'user-path-animation-set-2': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-2': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Kies je geslacht")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"g-1","value":"male","name":"male"},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),_c('label',{attrs:{"for":"g-1"}},[_vm._v("Man")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"g-2","value":"female","name":"female"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),_c('label',{attrs:{"for":"g-2"}},[_vm._v("Vrouw")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"g-3","value":"anders","name":"anders"},domProps:{"checked":_vm._q(_vm.gender,"anders")},on:{"change":function($event){_vm.gender="anders"}}}),_vm._v(" "),_c('label',{attrs:{"for":"g-3"}},[_vm._v("Anders")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","id":"g-4","value":"zegiklieverniet","name":"zegiklieverniet"},domProps:{"checked":_vm._q(_vm.gender,"zegiklieverniet")},on:{"change":function($event){_vm.gender="zegiklieverniet"}}}),_vm._v(" "),_c('label',{attrs:{"for":"g-4"}},[_vm._v("Zeg ik liever niet")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(!_vm.gender && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-03"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Overslaan\n          ")]):_vm._e(),_vm._v(" "),(_vm.gender && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-03"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 4)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Wat is je opleidingsniveau?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-4': _vm.progressActive, 'user-path-animation-set-3': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-3': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Kies je opleidingsniveau")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-1","value":"basis","name":"basis"},domProps:{"checked":_vm._q(_vm.highest_education,"basis")},on:{"change":function($event){_vm.highest_education="basis"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-1"}},[_vm._v("Basis")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-2","value":"vmbo","name":"vmbo"},domProps:{"checked":_vm._q(_vm.highest_education,"vmbo")},on:{"change":function($event){_vm.highest_education="vmbo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-2"}},[_vm._v("VMBO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-3","value":"havo","name":"havo"},domProps:{"checked":_vm._q(_vm.highest_education,"havo")},on:{"change":function($event){_vm.highest_education="havo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-3"}},[_vm._v("HAVO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-4","value":"vwo","name":"vwo"},domProps:{"checked":_vm._q(_vm.highest_education,"vwo")},on:{"change":function($event){_vm.highest_education="vwo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-4"}},[_vm._v("VWO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-5","value":"mbo","name":"mbo"},domProps:{"checked":_vm._q(_vm.highest_education,"mbo")},on:{"change":function($event){_vm.highest_education="mbo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-5"}},[_vm._v("MBO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-6","value":"hbo","name":"hbo"},domProps:{"checked":_vm._q(_vm.highest_education,"hbo")},on:{"change":function($event){_vm.highest_education="hbo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-6"}},[_vm._v("HBO")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.highest_education),expression:"highest_education"}],attrs:{"type":"radio","id":"he-7","value":"wo","name":"wo"},domProps:{"checked":_vm._q(_vm.highest_education,"wo")},on:{"change":function($event){_vm.highest_education="wo"}}}),_vm._v(" "),_c('label',{attrs:{"for":"he-7"}},[_vm._v("WO")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.highest_education && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-04"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 5 && !_vm.unemployed)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Heb je op dit moment een baan?")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-5': _vm.progressActive, 'user-path-animation-set-4': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-4': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Heb je op dit moment een baan?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.job),expression:"job"}],attrs:{"type":"radio","id":"j-1","value":"yes","name":"yes"},domProps:{"checked":_vm._q(_vm.job,"yes")},on:{"change":function($event){_vm.job="yes"}}}),_vm._v(" "),_c('label',{attrs:{"for":"j-1"}},[_vm._v("Ja")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.job),expression:"job"}],attrs:{"type":"radio","id":"j-2","value":"no","name":"no"},domProps:{"checked":_vm._q(_vm.job,"no")},on:{"change":function($event){_vm.job="no"}}}),_vm._v(" "),_c('label',{attrs:{"for":"j-2"}},[_vm._v("Nee")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.job === 'yes' && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-05"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e(),_vm._v(" "),(_vm.job === 'no' && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-05"},on:{"click":function($event){$event.preventDefault();return _vm.noJob($event)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 6)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Wat is je functieniveau?")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-6': _vm.progressActive, 'user-path-animation-set-5': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-5': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Wat is je functieniveau?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-1","value":"zzp_zmp","name":"zzp_zmp"},domProps:{"checked":_vm._q(_vm.functional_level,"zzp_zmp")},on:{"change":function($event){_vm.functional_level="zzp_zmp"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-1"}},[_vm._v("ZZP/ZMP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-2","value":"director","name":"director"},domProps:{"checked":_vm._q(_vm.functional_level,"director")},on:{"change":function($event){_vm.functional_level="director"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-2"}},[_vm._v("Directeur")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-3","value":"manager","name":"manager"},domProps:{"checked":_vm._q(_vm.functional_level,"manager")},on:{"change":function($event){_vm.functional_level="manager"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-3"}},[_vm._v("Manager")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-4","value":"teamleader_coordinator","name":"teamleader_coordinator"},domProps:{"checked":_vm._q(_vm.functional_level,"teamleader_coordinator")},on:{"change":function($event){_vm.functional_level="teamleader_coordinator"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-4"}},[_vm._v("Teamleider/coördinator")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-5","value":"advisor","name":"advisor"},domProps:{"checked":_vm._q(_vm.functional_level,"advisor")},on:{"change":function($event){_vm.functional_level="advisor"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-5"}},[_vm._v("Adviseur")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-6","value":"researcher","name":"researcher"},domProps:{"checked":_vm._q(_vm.functional_level,"researcher")},on:{"change":function($event){_vm.functional_level="researcher"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-6"}},[_vm._v("Onderzoeker")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.functional_level),expression:"functional_level"}],attrs:{"type":"radio","id":"f-7","value":"support_operational","name":"support_operational"},domProps:{"checked":_vm._q(_vm.functional_level,"support_operational")},on:{"change":function($event){_vm.functional_level="support_operational"}}}),_vm._v(" "),_c('label',{attrs:{"for":"f-7"}},[_vm._v("Ondersteunend/uitvoerend")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.functional_level && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-06"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 7)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("In welke sector ben je werkzaam?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-7': _vm.progressActive, 'user-path-animation-set-6': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-6': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer align-left"},[_c('div',{staticClass:"label"},[_vm._v("Kies je sector")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-1","value":"trade_transport_hospitality","name":"trade_transport_hospitality"},domProps:{"checked":_vm._q(_vm.sector,"trade_transport_hospitality")},on:{"change":function($event){_vm.sector="trade_transport_hospitality"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-1"}},[_vm._v("Handel, vervoer en horeca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-2","value":"business_services","name":"business_services"},domProps:{"checked":_vm._q(_vm.sector,"business_services")},on:{"change":function($event){_vm.sector="business_services"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-2"}},[_vm._v("Zakelijke dienstverlening")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-3","value":"healthcare","name":"healthcare"},domProps:{"checked":_vm._q(_vm.sector,"healthcare")},on:{"change":function($event){_vm.sector="healthcare"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-3"}},[_vm._v("Zorg en welzijn")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-4","value":"culture_recreation_other","name":"culture_recreation_other"},domProps:{"checked":_vm._q(_vm.sector,"culture_recreation_other")},on:{"change":function($event){_vm.sector="culture_recreation_other"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-4"}},[_vm._v("Cultuur, recreatie, overige diensten")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-5","value":"industry","name":"industry"},domProps:{"checked":_vm._q(_vm.sector,"industry")},on:{"change":function($event){_vm.sector="industry"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-5"}},[_vm._v("Industrie")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-6","value":"public_service_government","name":"public_service_government"},domProps:{"checked":_vm._q(_vm.sector,"public_service_government")},on:{"change":function($event){_vm.sector="public_service_government"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-6"}},[_vm._v("Openbaar bestuur/overheid")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-7","value":"education","name":"education"},domProps:{"checked":_vm._q(_vm.sector,"education")},on:{"change":function($event){_vm.sector="education"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-7"}},[_vm._v("Onderwijs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-8","value":"rental_trade_property","name":"rental_trade_property"},domProps:{"checked":_vm._q(_vm.sector,"rental_trade_property")},on:{"change":function($event){_vm.sector="rental_trade_property"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-8"}},[_vm._v("Verhuur en handel van onroerend goed")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-9","value":"information_communication","name":"information_communication"},domProps:{"checked":_vm._q(_vm.sector,"information_communication")},on:{"change":function($event){_vm.sector="information_communication"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-9"}},[_vm._v("Informatie en communicatie")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-10","value":"construction","name":"construction"},domProps:{"checked":_vm._q(_vm.sector,"construction")},on:{"change":function($event){_vm.sector="construction"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-10"}},[_vm._v("Bouwnijverheid")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-11","value":"financial_services","name":"financial_services"},domProps:{"checked":_vm._q(_vm.sector,"financial_services")},on:{"change":function($event){_vm.sector="financial_services"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-11"}},[_vm._v("Financiële dienstverlening")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sector),expression:"sector"}],attrs:{"type":"radio","id":"s-12","value":"agriculture_fishery","name":"agriculture_fishery"},domProps:{"checked":_vm._q(_vm.sector,"agriculture_fishery")},on:{"change":function($event){_vm.sector="agriculture_fishery"}}}),_vm._v(" "),_c('label',{attrs:{"for":"s-12"}},[_vm._v("Landbouw en visserij")])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.sector && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-07"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 8)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Wanneer je nadenkt over je eigen\n                leven,\n                hoe gelukkig ben je?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-8': _vm.progressActive, 'user-path-animation-set-7': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-7': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Geef een cijfer")]),_vm._v(" "),_c('div',{staticClass:"radio-elements"},[_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-1","value":"1","name":"one"},domProps:{"checked":_vm._q(_vm.happiness,"1")},on:{"change":function($event){_vm.happiness="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-1"}},[_vm._v("1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-2","value":"2","name":"two"},domProps:{"checked":_vm._q(_vm.happiness,"2")},on:{"change":function($event){_vm.happiness="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-2"}},[_vm._v("2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-3","value":"3","name":"three"},domProps:{"checked":_vm._q(_vm.happiness,"3")},on:{"change":function($event){_vm.happiness="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-3"}},[_vm._v("3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-4","value":"4","name":"four"},domProps:{"checked":_vm._q(_vm.happiness,"4")},on:{"change":function($event){_vm.happiness="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-4"}},[_vm._v("4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-5","value":"5","name":"five"},domProps:{"checked":_vm._q(_vm.happiness,"5")},on:{"change":function($event){_vm.happiness="5"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-5"}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-6","value":"6","name":"six"},domProps:{"checked":_vm._q(_vm.happiness,"6")},on:{"change":function($event){_vm.happiness="6"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-6"}},[_vm._v("6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-7","value":"7","name":"seven"},domProps:{"checked":_vm._q(_vm.happiness,"7")},on:{"change":function($event){_vm.happiness="7"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-7"}},[_vm._v("7")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-8","value":"8","name":"eight"},domProps:{"checked":_vm._q(_vm.happiness,"8")},on:{"change":function($event){_vm.happiness="8"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-8"}},[_vm._v("8")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-9","value":"9","name":"nine"},domProps:{"checked":_vm._q(_vm.happiness,"9")},on:{"change":function($event){_vm.happiness="9"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-9"}},[_vm._v("9")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness),expression:"happiness"}],attrs:{"type":"radio","id":"h-10","value":"10","name":"ten"},domProps:{"checked":_vm._q(_vm.happiness,"10")},on:{"change":function($event){_vm.happiness="10"}}}),_vm._v(" "),_c('label',{attrs:{"for":"h-10"}},[_vm._v("10")])])])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.happiness && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-08"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 9)?_c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.leftFadeOut, 'fade-in': _vm.leftFadeIn }},[_c('div',{staticClass:"left-contents"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Wanneer je nadenkt over je eigen\n                baan,\n                hoe gelukkig ben je met je werk/ in je\n                werksituatie?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'user-path-animation-9': _vm.progressActive, 'user-path-animation-set-8': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'user-path-animation-8': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Geef een cijfer")]),_vm._v(" "),_c('div',{staticClass:"radio-elements"},[_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-1","value":"1","name":"one"},domProps:{"checked":_vm._q(_vm.happiness_job,"1")},on:{"change":function($event){_vm.happiness_job="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-1"}},[_vm._v("1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-2","value":"2","name":"two"},domProps:{"checked":_vm._q(_vm.happiness_job,"2")},on:{"change":function($event){_vm.happiness_job="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-2"}},[_vm._v("2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-3","value":"3","name":"three"},domProps:{"checked":_vm._q(_vm.happiness_job,"3")},on:{"change":function($event){_vm.happiness_job="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-3"}},[_vm._v("3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-4","value":"4","name":"four"},domProps:{"checked":_vm._q(_vm.happiness_job,"4")},on:{"change":function($event){_vm.happiness_job="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-4"}},[_vm._v("4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-5","value":"5","name":"five"},domProps:{"checked":_vm._q(_vm.happiness_job,"5")},on:{"change":function($event){_vm.happiness_job="5"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-5"}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-6","value":"6","name":"six"},domProps:{"checked":_vm._q(_vm.happiness_job,"6")},on:{"change":function($event){_vm.happiness_job="6"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-6"}},[_vm._v("6")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-7","value":"7","name":"seven"},domProps:{"checked":_vm._q(_vm.happiness_job,"7")},on:{"change":function($event){_vm.happiness_job="7"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-7"}},[_vm._v("7")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-8","value":"8","name":"eight"},domProps:{"checked":_vm._q(_vm.happiness_job,"8")},on:{"change":function($event){_vm.happiness_job="8"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-8"}},[_vm._v("8")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-9","value":"9","name":"nine"},domProps:{"checked":_vm._q(_vm.happiness_job,"9")},on:{"change":function($event){_vm.happiness_job="9"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-9"}},[_vm._v("9")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.happiness_job),expression:"happiness_job"}],attrs:{"type":"radio","id":"hj-10","value":"10","name":"ten"},domProps:{"checked":_vm._q(_vm.happiness_job,"10")},on:{"change":function($event){_vm.happiness_job="10"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hj-10"}},[_vm._v("10")])])])])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.happiness_job && !_vm.nextStepActive)?_c('button',{staticClass:"next-step",attrs:{"id":"question-09"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(true)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 10)?_c('div',[_c('div',{staticClass:"solidarity"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.rightFadeOut, 'fade-in': _vm.rightFadeIn }},[_c('div',{staticClass:"left-contents"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"question fade-in",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Op het werk voel ik me\n                onderdeel\n                van een groep\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation': _vm.progressActive },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"part-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.part,"4")},on:{"change":function($event){_vm.part="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"part-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"agree",attrs:{"type":"radio","id":"part-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.part,"3")},on:{"change":function($event){_vm.part="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"part-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"neutral",attrs:{"type":"radio","id":"part-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.part,"2")},on:{"change":function($event){_vm.part="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"part-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"disagree",attrs:{"type":"radio","id":"part-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.part,"1")},on:{"change":function($event){_vm.part="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"part-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.part),expression:"part"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"part-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.part,"0")},on:{"change":function($event){_vm.part="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"part-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.part)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(true)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.part && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-10"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 11)?_c('div',[_c('div',{staticClass:"solidarity"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-2': _vm.progressActive, 'path-animation-set': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.important),expression:"important"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"important-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.important,"4")},on:{"change":function($event){_vm.important="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"important-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.important),expression:"important"}],staticClass:"agree",attrs:{"type":"radio","id":"important-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.important,"3")},on:{"change":function($event){_vm.important="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"important-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.important),expression:"important"}],staticClass:"neutral",attrs:{"type":"radio","id":"important-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.important,"2")},on:{"change":function($event){_vm.important="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"important-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.important),expression:"important"}],staticClass:"disagree",attrs:{"type":"radio","id":"important-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.important,"1")},on:{"change":function($event){_vm.important="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"important-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.important),expression:"important"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"important-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.important,"0")},on:{"change":function($event){_vm.important="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"important-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.important)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.important && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-11"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 12)?_c('div',[_c('div',{staticClass:"solidarity"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-3': _vm.progressActive, 'path-animation-set-2': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-2': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friends),expression:"friends"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"friends-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.friends,"4")},on:{"change":function($event){_vm.friends="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friends-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friends),expression:"friends"}],staticClass:"agree",attrs:{"type":"radio","id":"friends-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.friends,"3")},on:{"change":function($event){_vm.friends="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friends-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friends),expression:"friends"}],staticClass:"neutral",attrs:{"type":"radio","id":"friends-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.friends,"2")},on:{"change":function($event){_vm.friends="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friends-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friends),expression:"friends"}],staticClass:"disagree",attrs:{"type":"radio","id":"friends-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.friends,"1")},on:{"change":function($event){_vm.friends="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friends-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friends),expression:"friends"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"friends-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.friends,"0")},on:{"change":function($event){_vm.friends="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friends-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.friends)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.friends && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-12"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 13)?_c('div',[_c('div',{staticClass:"solidarity"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.leftFadeOut, 'fade-in': _vm.leftFadeIn }},[_c('div',{staticClass:"left-contents"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Op het werk zijn er mensen die me\n                echt\n                begrijpen\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-4': _vm.progressActive, 'path-animation-set-3': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-3': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.understand),expression:"understand"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"understand-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.understand,"4")},on:{"change":function($event){_vm.understand="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"understand-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.understand),expression:"understand"}],staticClass:"agree",attrs:{"type":"radio","id":"understand-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.understand,"3")},on:{"change":function($event){_vm.understand="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"understand-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.understand),expression:"understand"}],staticClass:"neutral",attrs:{"type":"radio","id":"understand-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.understand,"2")},on:{"change":function($event){_vm.understand="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"understand-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.understand),expression:"understand"}],staticClass:"disagree",attrs:{"type":"radio","id":"understand-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.understand,"1")},on:{"change":function($event){_vm.understand="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"understand-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.understand),expression:"understand"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"understand-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.understand,"0")},on:{"change":function($event){_vm.understand="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"understand-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.understand)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.understand && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-13"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(true)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 14)?_c('div',[_c('div',{staticClass:"competence"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.rightFadeOut, 'fade-in': _vm.rightFadeIn }},[_vm._m(14)]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation': _vm.progressActive },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.control),expression:"control"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"control-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.control,"4")},on:{"change":function($event){_vm.control="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"control-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.control),expression:"control"}],staticClass:"agree",attrs:{"type":"radio","id":"control-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.control,"3")},on:{"change":function($event){_vm.control="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"control-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.control),expression:"control"}],staticClass:"neutral",attrs:{"type":"radio","id":"control-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.control,"2")},on:{"change":function($event){_vm.control="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"control-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.control),expression:"control"}],staticClass:"disagree",attrs:{"type":"radio","id":"control-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.control,"1")},on:{"change":function($event){_vm.control="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"control-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.control),expression:"control"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"control-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.control,"0")},on:{"change":function($event){_vm.control="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"control-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.control)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(true)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.control && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-14"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 15)?_c('div',[_c('div',{staticClass:"competence"},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-2': _vm.progressActive, 'path-animation-set': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.performance),expression:"performance"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"performance-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.performance,"4")},on:{"change":function($event){_vm.performance="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"performance-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.performance),expression:"performance"}],staticClass:"agree",attrs:{"type":"radio","id":"performance-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.performance,"3")},on:{"change":function($event){_vm.performance="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"performance-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.performance),expression:"performance"}],staticClass:"neutral",attrs:{"type":"radio","id":"performance-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.performance,"2")},on:{"change":function($event){_vm.performance="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"performance-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.performance),expression:"performance"}],staticClass:"disagree",attrs:{"type":"radio","id":"performance-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.performance,"1")},on:{"change":function($event){_vm.performance="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"performance-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.performance),expression:"performance"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"performance-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.performance,"0")},on:{"change":function($event){_vm.performance="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"performance-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.performance)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.performance && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-15"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 16)?_c('div',[_c('div',{staticClass:"competence"},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-3': _vm.progressActive, 'path-animation-set-2': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-2': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doing_well),expression:"doing_well"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"doing-well-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.doing_well,"4")},on:{"change":function($event){_vm.doing_well="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"doing-well-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doing_well),expression:"doing_well"}],staticClass:"agree",attrs:{"type":"radio","id":"doing-well-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.doing_well,"3")},on:{"change":function($event){_vm.doing_well="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"doing-well-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doing_well),expression:"doing_well"}],staticClass:"neutral",attrs:{"type":"radio","id":"doing-well-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.doing_well,"2")},on:{"change":function($event){_vm.doing_well="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"doing-well-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doing_well),expression:"doing_well"}],staticClass:"disagree",attrs:{"type":"radio","id":"doing-well-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.doing_well,"1")},on:{"change":function($event){_vm.doing_well="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"doing-well-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.doing_well),expression:"doing_well"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"doing-well-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.doing_well,"0")},on:{"change":function($event){_vm.doing_well="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"doing-well-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.doing_well)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.doing_well && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-16"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 17)?_c('div',[_c('div',{staticClass:"competence"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.leftFadeOut, 'fade-in': _vm.leftFadeIn }},[_c('div',{staticClass:"left-contents"},[_vm._m(17),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Ik heb het gevoel dat ik zelfs de\n                moeilijkste taken op mijn werk kan volbrengen\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-4': _vm.progressActive, 'path-animation-set-3': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-3': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hardest_tasks),expression:"hardest_tasks"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"hardest-tasks-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.hardest_tasks,"4")},on:{"change":function($event){_vm.hardest_tasks="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hardest-tasks-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hardest_tasks),expression:"hardest_tasks"}],staticClass:"agree",attrs:{"type":"radio","id":"hardest-tasks-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.hardest_tasks,"3")},on:{"change":function($event){_vm.hardest_tasks="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hardest-tasks-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hardest_tasks),expression:"hardest_tasks"}],staticClass:"neutral",attrs:{"type":"radio","id":"hardest-tasks-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.hardest_tasks,"2")},on:{"change":function($event){_vm.hardest_tasks="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hardest-tasks-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hardest_tasks),expression:"hardest_tasks"}],staticClass:"disagree",attrs:{"type":"radio","id":"hardest-tasks-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.hardest_tasks,"1")},on:{"change":function($event){_vm.hardest_tasks="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hardest-tasks-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hardest_tasks),expression:"hardest_tasks"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"hardest-tasks-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.hardest_tasks,"0")},on:{"change":function($event){_vm.hardest_tasks="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"hardest-tasks-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.hardest_tasks)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.hardest_tasks && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-17"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(true)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 18)?_c('div',[_c('div',{staticClass:"autonomy"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.rightFadeOut, 'fade-in': _vm.rightFadeIn }},[_vm._m(18)]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation': _vm.progressActive },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expression),expression:"expression"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"expression-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.expression,"4")},on:{"change":function($event){_vm.expression="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"expression-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expression),expression:"expression"}],staticClass:"agree",attrs:{"type":"radio","id":"expression-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.expression,"3")},on:{"change":function($event){_vm.expression="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"expression-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expression),expression:"expression"}],staticClass:"neutral",attrs:{"type":"radio","id":"expression-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.expression,"2")},on:{"change":function($event){_vm.expression="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"expression-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expression),expression:"expression"}],staticClass:"disagree",attrs:{"type":"radio","id":"expression-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.expression,"1")},on:{"change":function($event){_vm.expression="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"expression-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expression),expression:"expression"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"expression-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.expression,"0")},on:{"change":function($event){_vm.expression="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"expression-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.expression)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.expression && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-19"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 19)?_c('div',[_c('div',{staticClass:"autonomy"},[_vm._m(19),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-2': _vm.progressActive, 'path-animation-set': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myself),expression:"myself"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"myself-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.myself,"4")},on:{"change":function($event){_vm.myself="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"myself-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myself),expression:"myself"}],staticClass:"agree",attrs:{"type":"radio","id":"myself-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.myself,"3")},on:{"change":function($event){_vm.myself="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"myself-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myself),expression:"myself"}],staticClass:"neutral",attrs:{"type":"radio","id":"myself-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.myself,"2")},on:{"change":function($event){_vm.myself="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"myself-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myself),expression:"myself"}],staticClass:"disagree",attrs:{"type":"radio","id":"myself-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.myself,"1")},on:{"change":function($event){_vm.myself="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"myself-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myself),expression:"myself"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"myself-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.myself,"0")},on:{"change":function($event){_vm.myself="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"myself-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.myself)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.myself && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-19"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 20)?_c('div',[_c('div',{staticClass:"autonomy"},[_vm._m(20),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-3': _vm.progressActive, 'path-animation-set-2': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-2': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.want),expression:"want"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"want-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.want,"4")},on:{"change":function($event){_vm.want="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"want-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.want),expression:"want"}],staticClass:"agree",attrs:{"type":"radio","id":"want-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.want,"3")},on:{"change":function($event){_vm.want="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"want-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.want),expression:"want"}],staticClass:"neutral",attrs:{"type":"radio","id":"want-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.want,"2")},on:{"change":function($event){_vm.want="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"want-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.want),expression:"want"}],staticClass:"disagree",attrs:{"type":"radio","id":"want-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.want,"1")},on:{"change":function($event){_vm.want="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"want-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.want),expression:"want"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"want-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.want,"0")},on:{"change":function($event){_vm.want="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"want-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.want)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.want && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-20"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 21)?_c('div',[_c('div',{staticClass:"autonomy"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.leftFadeOut, 'fade-in': _vm.leftFadeIn }},[_c('div',{staticClass:"left-contents"},[_vm._m(21),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Ik voel me vrij om mijn werk te doen\n                zoals\n                ik denk dat dit het beste kan worden\n                gedaan\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-4': _vm.progressActive, 'path-animation-set-3': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-3': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.best),expression:"best"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"best-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.best,"4")},on:{"change":function($event){_vm.best="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"best-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.best),expression:"best"}],staticClass:"agree",attrs:{"type":"radio","id":"best-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.best,"3")},on:{"change":function($event){_vm.best="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"best-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.best),expression:"best"}],staticClass:"neutral",attrs:{"type":"radio","id":"best-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.best,"2")},on:{"change":function($event){_vm.best="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"best-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.best),expression:"best"}],staticClass:"disagree",attrs:{"type":"radio","id":"best-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.best,"1")},on:{"change":function($event){_vm.best="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"best-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.best),expression:"best"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"best-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.best,"0")},on:{"change":function($event){_vm.best="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"best-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.best)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.best && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-21"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(true)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 22)?_c('div',[_c('div',{staticClass:"social"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.rightFadeOut, 'fade-in': _vm.rightFadeIn }},[_vm._m(22)]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation': _vm.progressActive },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meaning),expression:"meaning"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"meaning-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.meaning,"4")},on:{"change":function($event){_vm.meaning="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"meaning-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meaning),expression:"meaning"}],staticClass:"agree",attrs:{"type":"radio","id":"meaning-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.meaning,"3")},on:{"change":function($event){_vm.meaning="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"meaning-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meaning),expression:"meaning"}],staticClass:"neutral",attrs:{"type":"radio","id":"meaning-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.meaning,"2")},on:{"change":function($event){_vm.meaning="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"meaning-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meaning),expression:"meaning"}],staticClass:"disagree",attrs:{"type":"radio","id":"meaning-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.meaning,"1")},on:{"change":function($event){_vm.meaning="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"meaning-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meaning),expression:"meaning"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"meaning-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.meaning,"0")},on:{"change":function($event){_vm.meaning="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"meaning-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.meaning)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(true)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.meaning && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-22"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 23)?_c('div',[_c('div',{staticClass:"social"},[_vm._m(23),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-2': _vm.progressActive, 'path-animation-set': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.matters),expression:"matters"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"matters-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.matters,"4")},on:{"change":function($event){_vm.matters="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"matters-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.matters),expression:"matters"}],staticClass:"agree",attrs:{"type":"radio","id":"matters-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.matters,"3")},on:{"change":function($event){_vm.matters="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"matters-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.matters),expression:"matters"}],staticClass:"neutral",attrs:{"type":"radio","id":"matters-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.matters,"2")},on:{"change":function($event){_vm.matters="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"matters-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.matters),expression:"matters"}],staticClass:"disagree",attrs:{"type":"radio","id":"matters-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.matters,"1")},on:{"change":function($event){_vm.matters="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"matters-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.matters),expression:"matters"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"matters-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.matters,"0")},on:{"change":function($event){_vm.matters="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"matters-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.matters)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.matters && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-23"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 24)?_c('div',[_c('div',{staticClass:"social"},[_vm._m(24),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-3': _vm.progressActive, 'path-animation-set-2': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-2': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contribute),expression:"contribute"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"contribute-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.contribute,"4")},on:{"change":function($event){_vm.contribute="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"contribute-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contribute),expression:"contribute"}],staticClass:"agree",attrs:{"type":"radio","id":"contribute-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.contribute,"3")},on:{"change":function($event){_vm.contribute="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"contribute-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contribute),expression:"contribute"}],staticClass:"neutral",attrs:{"type":"radio","id":"contribute-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.contribute,"2")},on:{"change":function($event){_vm.contribute="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"contribute-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contribute),expression:"contribute"}],staticClass:"disagree",attrs:{"type":"radio","id":"contribute-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.contribute,"1")},on:{"change":function($event){_vm.contribute="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"contribute-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contribute),expression:"contribute"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"contribute-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.contribute,"0")},on:{"change":function($event){_vm.contribute="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"contribute-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.contribute)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.contribute && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-bes",attrs:{"id":"question-24"},on:{"click":function($event){$event.preventDefault();_vm.nextStep(false)}}},[_vm._v("\n            Volgende\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 25)?_c('div',[_c('div',{staticClass:"social"},[_c('div',{staticClass:"left",class:{ 'fade-out': _vm.nextStepActive }},[_c('div',{staticClass:"left-contents"},[_vm._m(25),_vm._v(" "),_c('div',{staticClass:"question",class:{ 'fade-out': _vm.nextStepActive }},[_vm._v("Ik zie duidelijk hoe mijn werk\n                bijdraagt\n                aan de maatschappij\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"base"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{staticClass:"path",class:{ 'path-animation-4': _vm.progressActive, 'path-animation-set-3': !_vm.progressActive, 'user-path-animation-reverse': _vm.progressBackReverse, 'path-animation-3': _vm.progressBackAnimation },attrs:{"fill":"none","stroke":"#F4F0EC","stroke-width":"15","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})]),_vm._v(" "),_c('div',{staticClass:"backline"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1280","height":"432","viewBox":"0 0 1280 432"}},[_c('path',{attrs:{"fill":"none","stroke":"#e71234","stroke-width":"13","d":"M1734.7145,435.314583 C1734.7145,371.510231 1652.33116,265.611235 1517.66209,411.210717 C1003.94998,966.618275 866.706019,416.162823 966.650845,289.017764 C998.595851,248.377228 1057.45677,241.314795 1098.11934,273.243911 C1138.78333,305.171609 1150.69291,362.337497 1113.90174,404.641175 C898.267118,652.584883 531.620914,279.697379 57.5527726,779.912796","transform":"rotate(14 1890.92 -1077.114)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer"},[_c('div',{staticClass:"label"},[_vm._v("Maak een keuze")]),_vm._v(" "),_c('div',{staticClass:"radio-elements emoticons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.society),expression:"society"}],staticClass:"totally-agree",attrs:{"type":"radio","id":"society-5","value":"4","name":"totallyAgree"},domProps:{"checked":_vm._q(_vm.society,"4")},on:{"change":function($event){_vm.society="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":"society-5"},on:{"mouseover":function($event){_vm.mouseOver('totallyAgree', 'Helemaal mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyAgree', 'Helemaal mee eens')}}},[_c('span',[_vm._v("Helemaal mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.society),expression:"society"}],staticClass:"agree",attrs:{"type":"radio","id":"society-4","value":"3","name":"agree"},domProps:{"checked":_vm._q(_vm.society,"3")},on:{"change":function($event){_vm.society="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"society-4"},on:{"mouseover":function($event){_vm.mouseOver('agree', 'Mee eens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('agree', 'Mee eens')}}},[_c('span',[_vm._v("Mee eens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.society),expression:"society"}],staticClass:"neutral",attrs:{"type":"radio","id":"society-3","value":"2","name":"neutral"},domProps:{"checked":_vm._q(_vm.society,"2")},on:{"change":function($event){_vm.society="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"society-3"},on:{"mouseover":function($event){_vm.mouseOver('neutral', 'Niet mee eens, niet mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('neutral', 'Niet mee eens, niet mee oneens')}}},[_c('span',[_vm._v("Niet mee eens, niet mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.society),expression:"society"}],staticClass:"disagree",attrs:{"type":"radio","id":"society-2","value":"1","name":"disagree"},domProps:{"checked":_vm._q(_vm.society,"1")},on:{"change":function($event){_vm.society="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"society-2"},on:{"mouseover":function($event){_vm.mouseOver('disagree', 'Mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('disagree', 'Mee oneens')}}},[_c('span',[_vm._v("Mee oneens")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.society),expression:"society"}],staticClass:"totally-disagree",attrs:{"type":"radio","id":"society-1","value":"0","name":"totallyDisagree"},domProps:{"checked":_vm._q(_vm.society,"0")},on:{"change":function($event){_vm.society="0"}}}),_vm._v(" "),_c('label',{attrs:{"for":"society-1"},on:{"mouseover":function($event){_vm.mouseOver('totallyDisagree', 'Helemaal mee oneens')},"mouseleave":_vm.mouseLeave,"click":function($event){_vm.mouseClick('totallyDisagree', 'Helemaal mee oneens')}}},[_c('span',[_vm._v("Helemaal mee oneens")])])]),_vm._v(" "),(_vm.hoverActive)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.opinions.totallyAgree)+"\n                "+_vm._s(_vm.opinions.agree)+"\n                "+_vm._s(_vm.opinions.neutral)+"\n                "+_vm._s(_vm.opinions.disagree)+"\n                "+_vm._s(_vm.opinions.totallyDisagree)+"\n              ")]):(!_vm.hideChecked && _vm.society)?_c('div',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.checked.totallyAgree)+"\n                "+_vm._s(_vm.checked.agree)+"\n                "+_vm._s(_vm.checked.neutral)+"\n                "+_vm._s(_vm.checked.disagree)+"\n                "+_vm._s(_vm.checked.totallyDisagree)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"previous-step btn-bes btn-prev",on:{"click":function($event){$event.preventDefault();_vm.previousStep(false)}}},[_vm._v("Vorige")]),_vm._v(" "),(_vm.society && !_vm.nextStepActive)?_c('button',{staticClass:"next-step btn-gras",attrs:{"id":"question-25","type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.finishUp($event)}}},[_vm._v("\n            Verzenden\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step === 26)?_c('div',[_c('div',{staticClass:"user user-results"},[_c('div',{staticClass:"left results",class:_vm.classResults},[_c('div',{staticClass:"left-contents"},[(_vm.success === false)?_c('div',{staticClass:"label-white-large fade-in"},[_vm._v("Volgens deze test is jouw werkgelukcijfer een")]):_vm._e(),_vm._v(" "),(_vm.success === true)?_c('div',{staticClass:"label-white-large fade-in"},[_vm._v("De tips zijn naar je verzonden")]):_vm._e(),_vm._v(" "),(_vm.success === false)?_c('div',{staticClass:"response heartBeat animated"},[_c('div',{staticClass:"emoticon",class:_vm.emotionsResults}),_vm._v("\n                "+_vm._s(_vm.grade)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.success === false)?_c('div',{staticClass:"speech-bubble explanation flipInX animated"},[_c('h3',[_vm._v("Deze score is gebaseerd op 4 factoren:")]),_vm._v(" "),_vm._m(26)]):_vm._e(),_vm._v(" "),(_vm.success === false)?_c('a',{staticClass:"button",attrs:{"href":"#subscribe"}},[_vm._v("ik wil graag tips ontvangen")]):_vm._e(),_vm._v(" "),(_vm.success === true)?_c('div',{staticClass:"response tips-sent"},[_vm._v("e")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.success === false)?_c('div',{staticClass:"tips"},[_c('h2',[_vm._v("Jouw werkgeluk vergroten?")]),_vm._v(" "),_c('p',{staticClass:"explanation"},[_vm._v("Deze score is gebaseerd op 4 factoren die invloed hebben op je werkgeluk; de\n                relatie met je\n                collega’s,\n                hoe goed jij je competenties kan benutten in je functie, de vrijheid die je hebt en de\n                maatschappelijke\n                relevantie die je werk heeft.")]),_vm._v(" "),_c('a',{attrs:{"id":"subscribe"}}),_vm._v(" "),_c('p',[_vm._v("Benieuwd hoe jij je werkgeluk kunt vergroten? Of wil je meer inzicht in jouw werkgelukcijfer? Waar scoor je hoog op en waar juist lager? Op basis van jouw score geven we je inzicht in de verschillende factoren én geven we je tips hoe jij je werkgeluk kunt vergroten. Laat hieronder je gegevens achter en je ontvangt de toelichting met tips in je e-mail.")]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Wat is je naam?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","name":"name","size":"60","maxlength":"60","placeholder":"Je naam"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Wat is je e-mailadres?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],class:{ error: _vm.errorActive && _vm.email },attrs:{"type":"email","name":"email","size":"60","maxlength":"60","placeholder":"Je e-mailadres"},domProps:{"value":(_vm.email)},on:{"keyup":_vm.removeError,"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newsletter),expression:"newsletter"}],attrs:{"type":"checkbox","id":"newsletter","value":"true"},domProps:{"checked":Array.isArray(_vm.newsletter)?_vm._i(_vm.newsletter,"true")>-1:(_vm.newsletter)},on:{"change":function($event){var $$a=_vm.newsletter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newsletter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newsletter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newsletter=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"newsletter"}},[_vm._v("Ik ga akkoord met de\n                  "),_c('router-link',{attrs:{"to":{ name: 'GeneralConditions'},"target":"_blank"}},[_vm._v("voorwaarden")]),_vm._v(".\n                  Naast de tips (eenmalig) ontvang ik ook de Werkgeluk kwartaalnieuwsbrief. Hiervoor kan ik mij op ieder gewenst moment eenvoudig afmelden.")],1)]),_vm._v(" "),(_vm.name && _vm.email && _vm.newsletter)?_c('button',{staticClass:"next-step btn-gras",attrs:{"id":"form-tips-sent","type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.checkForm($event)}}},[_vm._v("\n                Verzenden\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.success === true)?_c('div',{staticClass:"tips"},[_c('h2',[_vm._v("Vind je werkgeluk bij Driessen")]),_vm._v(" "),_c('p',[_vm._v("Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,\n                het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren\n                of zorg je voor anderen. Werk dat de maatschappij mooier en gelukkiger maakt.")]),_vm._v(" "),_c('p',[_vm._v("Veel werkgeluk toegewenst!")]),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.unemployed)?_c('div',[_vm._m(29)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo logo-desktop",attrs:{"src":__webpack_require__(30),"alt":"Driessen Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo logo-mobile",attrs:{"src":__webpack_require__(31),"alt":"Driessen Logo"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 1 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("ALGEMEEN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 2 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("VERBONDENHEID")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 2 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("VERBONDENHEID")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Op het werk kan ik met mensen praten over dingen die echt belangrijk voor me zijn\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 2 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("VERBONDENHEID")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Sommige mensen met wie ik werk, zijn goede vrienden van me")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 2 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("VERBONDENHEID")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 3 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("COMPETENTIE")])]),_vm._v(" "),_c('div',{staticClass:"question fade-in"},[_vm._v("Ik beheers de taken op mijn werk")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 3 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("COMPETENTIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Ik kan mijn werk goed uitvoeren")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 3 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("COMPETENTIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Ik ben goed in de dingen die ik in mijn werk doe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 3 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("COMPETENTIE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 4 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("AUTONOMIE")])]),_vm._v(" "),_c('div',{staticClass:"question fade-in"},[_vm._v("Ik voel me vrij om mijn ideeën en meningen in mijn werk uit te drukken\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 4 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("AUTONOMIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Ik heb het gevoel dat ik mezelf kan zijn in mijn werk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 4 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("AUTONOMIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("De taken die ik op mijn werk moet doen, liggen in de lijn van wat ik echt wil doen\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 4 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("AUTONOMIE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 5 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("MAATSCHAPPELIJKE RELEVANTIE")])]),_vm._v(" "),_c('div',{staticClass:"question fade-in"},[_vm._v("In mijn werk kan ik iets betekenen voor anderen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 5 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("MAATSCHAPPELIJKE RELEVANTIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Ik heb het gevoel dat mijn werk ertoe doet")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 5 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("MAATSCHAPPELIJKE RELEVANTIE")])]),_vm._v(" "),_c('div',{staticClass:"question"},[_vm._v("Ik zie duidelijk hoe mijn eigen werk bijdraagt aan de organisatie")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator fade-in"},[_c('span',{staticClass:"progress-indicator__theme"},[_vm._v("THEMA")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__current"},[_vm._v(" 5 ")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__total"},[_vm._v("/ 5")]),_vm._v(" "),_c('span',{staticClass:"progress-indicator__chapter"},[_vm._v("MAATSCHAPPELIJKE RELEVANTIE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"checklist checklist--green"},[_c('li',[_vm._v("je relatie met collega's")]),_vm._v(" "),_c('li',[_vm._v("je competenties")]),_vm._v(" "),_c('li',[_vm._v("je vrijheid in je werk")]),_vm._v(" "),_c('li',[_vm._v("je manier van mensen gelukkig maken")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"button button--margin",attrs:{"href":"https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("bekijk onze vacatures")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[_vm._v("\n                of   "),_c('a',{staticClass:"button",attrs:{"href":"https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("schrijf je gratis in")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"left results"},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"label-white-large fade-in"},[_vm._v("Helaas kunnen wij jouw werkgeluk niet meten.")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"tips"},[_c('h2',[_vm._v("Op zoek naar werk waar jij je talent in kwijt kunt?")]),_vm._v(" "),_c('p',[_vm._v("Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,\n                het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren\n                of zorg je voor anderen. Werk dat de maatschappij mooier én gelukkiger maakt. Benieuwd naar de\n                vacatures? Bekijk "),_c('a',{attrs:{"href":"https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("hier")]),_vm._v(" alle vacatures en solliciteer direct.")]),_vm._v(" "),_c('p',[_vm._v("Veel succes toegewenst!")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Schrijf je in")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cookies"}},[_c('div',{staticClass:"content"},[_c('header',[_c('div',{staticClass:"row-inner"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo logo-desktop",attrs:{"src":__webpack_require__(30),"alt":"Driessen Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo logo-mobile",attrs:{"src":__webpack_require__(31),"alt":"Driessen Logo"}})])])]),_vm._v(" "),_c('main',[_c('h1',[_vm._v("Cookies")]),_vm._v(" "),_c('div',{staticClass:"row-inner content-style content-style--white"},[_c('p',[_vm._v("Onze website maakt gebruik van cookies. Dit zijn kleine tekstbestandjes die bij een bezoek op de harde schijf van uw computer worden geplaatst. Een cookie bevat gegevens waarmee uw computer kan worden herkend, bijvoorbeeld bij herbezoek. Op deze wijze kunnen wij bijvoorbeeld onderdelen van onze website afstemmen op uw persoonlijke voorkeuren en het gebruiksgemak van onze website\n          verbeteren.")]),_vm._v(" "),_c('h3',[_vm._v("Soorten cookies")]),_vm._v(" "),_c('p',[_vm._v("Wij gebruiken 3 typen cookies:")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("Essentiële cookies")]),_c('br'),_vm._v("\n            Deze cookies zorgen ervoor dat deze website naar behoren functioneert. Ook houden we met deze cookies anoniem website statistieken bij.\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Analytische cookies")]),_c('br'),_vm._v("\n            Deze cookies verzamelen informatie die wordt gebruikt om ons te helpen begrijpen hoe onze website wordt gebruikt of hoe effectief onze marketingcampagnes zijn. Ook helpen deze cookies ons om deze website aan te passen en zo de gebruikservaring te kunnen verbeteren.\n          ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Advertentie cookies")]),_c('br'),_vm._v("\n            Met deze cookies kan uw surfgedrag worden gemonitord door advertentienetwerken waardoor we advertenties kunnen tonen op basis van interesses en surfgedrag. Ook voeren deze cookies functies uit waarmee onder andere wordt voorkomen dat dezelfde advertentie voortdurend verschijnt.\n          ")])]),_vm._v(" "),_c('h3',[_vm._v("Uw cookie instellingen wijzigen?")]),_vm._v(" "),_c('p',[_vm._v("Wilt u uw huidige cookie instellingen wijzigen, "),_c('a',{staticClass:"csconsentlink",attrs:{"href":"javascript:void(0)"}},[_vm._v("klik dan hier")]),_vm._v(".")]),_vm._v(" "),_c('h3',[_vm._v("Privacy statements website-partners")]),_vm._v(" "),_c('p',[_vm._v("Onze website-partners hanteren de volgende privacy statements:")]),_vm._v(" "),_c('ul',{staticClass:"disc"},[_c('li',[_c('a',{attrs:{"href":"http://www.hotjar.com/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Privacybeleid HotJar")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://policies.google.com/privacy","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Privacybeleid Google (Analytics & DoubleClick)")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/about/privacy/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Privacybeleid Facebook")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://privacy.linkedin.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Privacybeleid LinkedIn")])])]),_vm._v(" "),_c('h3',[_vm._v("Liever helemaal geen cookies?")]),_vm._v(" "),_c('p',[_vm._v("U kunt er voor kiezen om in uw browser cookies (altijd) buiten werking te stellen. Raadpleeg hiervoor de helpfunctie van uw browser. Dit kan echter wel als gevolg hebben dat bepaalde onderdelen van onze website niet of minder goed toegankelijk voor u zijn.")])])]),_vm._v(" "),_c('footer',[_c('div',{staticClass:"row-inner"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"logo-footer"},[_c('img',{staticClass:"logo-drop",attrs:{"src":__webpack_require__(57),"alt":"Driessen Logo"}})]),_vm._v(" "),_c('div',{staticClass:"social-links follow"},[_c('span',{staticClass:"label"},[_vm._v("Volg ons")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Facebook")])]),_vm._v(" "),_c('li',{staticClass:"linkedin"},[_c('a',{attrs:{"href":"https://www.linkedin.com/company/driessen-nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("LinkedIn")])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/Driessen_nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',{staticClass:"youtube"},[_c('a',{attrs:{"href":"https://www.youtube.com/user/DriessenHRM","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Whatsapp")])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Instagram")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"general-conditions"}},[_c('div',{staticClass:"content"},[_c('header',[_c('div',{staticClass:"row-inner"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo logo-desktop",attrs:{"src":__webpack_require__(30),"alt":"Driessen Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo logo-mobile",attrs:{"src":__webpack_require__(31),"alt":"Driessen Logo"}})])])]),_vm._v(" "),_c('main',[_c('h1',[_vm._v("Algemene voorwaarden")]),_vm._v(" "),_c('div',{staticClass:"row-inner content-style content-style--white"},[_c('h2',[_vm._v("Privacy beleid www.testjewerkgeluk.nl")]),_vm._v(" "),_c('p',[_vm._v("Driessen neemt de privacy van haar bezoekers zeer serieus en zal persoonlijke gegevens over u\n          op een veilige\n          manier verwerken en gebruiken. Hierbij houdt Driessen zich aan de wet- en regelgeving op het gebied van de\n          bescherming van persoonsgegevens, zoals de Algemene verordening gegevensbescherming (AVG).")]),_vm._v(" "),_c('h3',[_vm._v("Gegevens van websitebezoekers")]),_vm._v(" "),_c('p',[_vm._v("In het algemeen kunt u onze website bezoeken zonder persoonsgegevens aan ons te verstrekken. Wel verzamelt Driessen, net als veel andere websites, bepaalde niet-identificeerbare automatische informatie, zoals het type browser waarvan u gebruik maakt, de datum en tijd van toegang tot de website, de regio van waaruit u onze website bezoekt en de pagina's en onderdelen van\n          de website die u bezoekt en informatie u bekijkt.")]),_vm._v(" "),_c('p',[_vm._v("De verzamelde gegevens worden gebruikt om de inhoud van de website optimaal af te stemmen op de wensen en de behoeftes van de bezoekers van onze website. Driessen kan deze informatie eventueel doorgeven aan derden. Deze gegevens kunnen worden bewaard voor toekomstig gebruik. Hiervoor maakt onze website gebruik van cookies. Zie voor meer informatie ons "),_c('a',{attrs:{"href":"/cookies"}},[_vm._v("cookie\n          statement")]),_vm._v(" of "),_c('a',{staticClass:"diffuse-cookie-settings",attrs:{"href":"#"}},[_vm._v("wijzig hier uw cookie instellingen")]),_vm._v(".")]),_vm._v(" "),_c('h3',[_vm._v("Doeleinden gegevensverzameling Werkgeluk test")]),_vm._v(" "),_c('p',[_vm._v("Wanneer u deelneemt aan de Werkgeluk test, worden de verzamelde gegevens (uw antwoorden) voor\n          de volgende\n          doeleinden gebruiken:")]),_vm._v(" "),_c('ol',{staticClass:"visible"},[_c('li',[_vm._v("om u op basis van uw antwoorden het resultaat (uitslag) te tonen van de Werkgeluk test;")]),_vm._v(" "),_c('li',[_vm._v("de resultaten (uitslagen) van deelnemers aan de Werkgeluk test worden geanonimiseerd samengevoegd en\n            dienen als benchmark, o.a. voor een onderzoek met publicatie(s) naar werkgeluk in Nederland;\n          ")]),_vm._v(" "),_c('li',[_vm._v("om geldende wet- en regelgeving na te kunnen komen (bijv. uw toestemming om u een e-mail toe te\n            sturen);\n          ")]),_vm._v(" "),_c('li',[_vm._v("eventueel kunt u ons toestemming geven om u te informeren over onze dienstverlening en overige\n            activiteiten (bijvoorbeeld via e-mail) en om u aanbiedingen te kunnen doen.\n          ")])]),_vm._v(" "),_c('h3',[_vm._v("Welke gegevens")]),_vm._v(" "),_c('p',[_vm._v("De Werkgeluk test verwerkt onder meer de volgende gegevens:")]),_vm._v(" "),_c('ul',{staticClass:"visible"},[_c('li',[_vm._v("provincie")]),_vm._v(" "),_c('li',[_vm._v("leeftijdscategorie")]),_vm._v(" "),_c('li',[_vm._v("opleidingsniveau")]),_vm._v(" "),_c('li',[_vm._v("functieniveau")]),_vm._v(" "),_c('li',[_vm._v("sector")]),_vm._v(" "),_c('li',[_vm._v("geslacht (niet verplicht)")]),_vm._v(" "),_c('li',[_vm._v("naam (niet verplicht)")]),_vm._v(" "),_c('li',[_vm._v("e-mailadres (niet verplicht)")]),_vm._v(" "),_c('li',[_vm._v("de antwoorden op gestelde vragen")])]),_vm._v(" "),_c('h3',[_vm._v("Gebruik door derden")]),_vm._v(" "),_c('p',[_vm._v("Driessen verstrekt persoonsgegevens die zijn verzameld via de Werkgeluk test niet aan\n          derden.")]),_vm._v(" "),_c('h3',[_vm._v("Bijzondere persoonsgegevens")]),_vm._v(" "),_c('p',[_vm._v("Driessen verwerkt uitsluitend bijzondere persoonsgegevens, voor zover u hier expliciet\n          toestemming voor\n          geeft, dan wel deze verwerking in overeenstemming is met de geldende wet- en/of regelgeving. Tot de\n          bijzondere persoonsgegevens die u aan Driessen verstrekt hebben alleen personen toegang die over deze\n          gegevens dienen te beschikken voor de (uitvoering van) hun werkzaamheden en/of ter voldoening aan de\n          geldende wet- en regelgeving.")]),_vm._v(" "),_c('h3',[_vm._v("Beveiliging")]),_vm._v(" "),_c('p',[_vm._v("Driessen heeft passende technische en organisatorische maatregelen genomen om uw\n          persoonsgegevens te\n          beveiligen tegen verlies of enige vorm van onrechtmatige verwerking. Uw persoonsgegevens kunnen worden\n          verwerkt buiten Nederland. Driessen heeft de nodige maatregelen genomen om te verzekeren dat alle\n          doorgegeven persoonsgegevens adequaat worden beschermd.")]),_vm._v(" "),_c('p',[_vm._v("Ondanks de door Driessen genomen veiligheidsmaatregelen, kan het voorkomen dat anderen er\n          toch in slagen\n          deze maatregelen te omzeilen en/of uw persoonsgegevens voor oneigenlijke doeleinden te gebruiken. Driessen\n          kan hiervoor nooit op enigerlei wijze aansprakelijk worden gesteld. Zie ook onze "),_c('a',{attrs:{"href":"https://www.driessen.nl/content/digitale-klokkenluidersregeling?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Digitale\n            klokkenluidersregeling")]),_vm._v(" (responsible disclosure procedure) op driessen.nl.")]),_vm._v(" "),_c('h3',[_vm._v("Bewaren van uw gegevens")]),_vm._v(" "),_c('p',[_vm._v("Driessen bewaart uw persoonsgegevens niet langer dan noodzakelijk voor de verwerkelijking van\n          de doeleinden\n          waarvoor zij zijn verzameld en worden verwerkt. Wij hanteren een bewaartermijn van 2 jaar.")]),_vm._v(" "),_c('h3',[_vm._v("Inzage in, wijziging en verwijdering van uw gegevens")]),_vm._v(" "),_c('p',[_vm._v("Als u inzage wenst in uw totale persoonsgegevensverwerking en/of gegevens wilt wijzigen of\n          verwijderen die u\n          zelf niet kunt aanpassen, dan kunt u contact opnemen met "),_c('a',{attrs:{"href":"mailto:communicatie@driessengroep.nl"}},[_vm._v("communicatie@driessengroep.nl")]),_vm._v("\n          of uw contactpersoon\n          bij Driessen.")]),_vm._v(" "),_c('h3',[_vm._v("Verwijzingen en links naar andere websites")]),_vm._v(" "),_c('p',[_vm._v("Op de website treft u een aantal links aan naar andere websites. Hoewel deze websites met\n          zorg zijn\n          geselecteerd, kan Driessen geen verantwoordelijkheid dragen met betrekking tot het gebruik van uw gegevens\n          door die organisaties. Op deze websites valt u onder de privacyregels van die betreffende website. Lees\n          daarom, indien aanwezig, het privacy statement van de website die u bezoekt.")]),_vm._v(" "),_c('h3',[_vm._v("Wijzigingen")]),_vm._v(" "),_c('p',[_vm._v("Driessen behoudt zich het recht voor om wijzigingen aan te brengen in dit privacy statement.\n          Check daarom\n          regelmatig het privacy statement voor een update van het privacy beleid.")]),_vm._v(" "),_c('h3',[_vm._v("Vragen, opmerkingen of klachten")]),_vm._v(" "),_c('p',[_vm._v("Indien u vragen, opmerkingen of klachten heeft met betrekking tot dit privacy statement of de\n          wijze waarop\n          Driessen uw gegevens registreert en verwerkt, dan kunt u contact met ons opnemen per e-mail via\n          "),_c('a',{attrs:{"href":"mailto:info@driessen.nl"}},[_vm._v("info@driessen.nl")]),_vm._v(" of door een brief te sturen naar Driessen, t.a.v.\n          Juridische Zaken, Postbus 748, 5700 AS\n          Helmond.")])])]),_vm._v(" "),_c('footer',[_c('div',{staticClass:"row-inner"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"logo-footer"},[_c('img',{staticClass:"logo-drop",attrs:{"src":__webpack_require__(57),"alt":"Driessen Logo"}})]),_vm._v(" "),_c('div',{staticClass:"social-links follow"},[_c('span',{staticClass:"label"},[_vm._v("Volg ons")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Facebook")])]),_vm._v(" "),_c('li',{staticClass:"linkedin"},[_c('a',{attrs:{"href":"https://www.linkedin.com/company/driessen-nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("LinkedIn")])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/Driessen_nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',{staticClass:"youtube"},[_c('a',{attrs:{"href":"https://www.youtube.com/user/DriessenHRM","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Whatsapp")])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/driessen.nl","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Instagram")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_silentbox__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Quiz__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Results__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cookies__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_GeneralConditions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_firebaseInit__ = __webpack_require__(37);










// A reference to the users collection.
var users = __WEBPACK_IMPORTED_MODULE_8__components_firebaseInit__["a" /* default */].collection('users');

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_silentbox__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/start-test',
    name: 'Quiz',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Quiz__["a" /* default */],
    props: function props(route) {
      return {
        debug: route.query.debug,
        step: route.query.step,
        grade: route.query.grade,
        email: route.query.email
      };
    }
  }, {
    path: '/results/:uid',
    name: 'Results',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Results__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      var docRef = users.doc(to.params.uid);
      docRef.get().then(function (documentSnapshot) {
        if (documentSnapshot.exists) {
          to.params.myCustomizations = {};
          next();
        } else {
          console.log('No such document!');
          next({ path: '/' });
        }
      });
    }
  }, {
    path: '/cookies',
    name: 'Cookies',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Cookies__["a" /* default */]
  }, {
    path: '/general-conditions',
    name: 'GeneralConditions',
    component: __WEBPACK_IMPORTED_MODULE_7__components_GeneralConditions__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_single_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_191c895c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_single_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_single_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_191c895c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_single_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{attrs:{"id":"silentbox-overlay"}},[_c('div',{attrs:{"id":"silentbox-overlay__background"},on:{"click":function($event){$event.stopPropagation();return _vm.closeSilentboxOverlay($event)}}}),_vm._v(" "),_c('div',{attrs:{"id":"silentbox-overlay__content"},on:{"click":function($event){$event.stopPropagation();return _vm.closeSilentboxOverlay($event)}}},[_c('div',{attrs:{"id":"silentbox-overlay__embed"}},[_c('div',{attrs:{"id":"silentbox-overlay__container"}},[(_vm.video)?_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.getEmbedUrl,"frameborder":"0","allowfullscreen":""}}):_vm._e(),_vm._v(" "),(! _vm.video)?_c('img',{attrs:{"width":"auto","height":"auto","src":_vm.getEmbedUrl}}):_vm._e()]),_vm._v(" "),(this.$parent.description)?_c('p',{attrs:{"id":"silentbox-overlay__description"}},[_vm._v(_vm._s(this.$parent.description))]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"silentbox-overlay__close-button","role":"button","tabindex":"3"},on:{"click":function($event){$event.stopPropagation();return _vm.closeSilentboxOverlay($event)},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.closeSilentboxOverlay($event)}}},[_c('div',{staticClass:"icon"})]),_vm._v(" "),(this.$parent.items.total > 0)?_c('div',{attrs:{"id":"silentbox-overlay__arrow-buttons"}},[_c('div',{staticClass:"arrow arrow-previous",attrs:{"role":"button","tabindex":"2"},on:{"click":_vm.moveToPreviousItem,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.moveToPreviousItem($event)}}}),_vm._v(" "),_c('div',{staticClass:"arrow arrow-next",attrs:{"role":"button","tabindex":"1"},on:{"click":_vm.moveToNextItem,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.moveToNextItem($event)}}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"silentbox-single",attrs:{"src":_vm.src},on:{"click":_vm.openSilentBoxOverlay}},[_vm._t("default"),_vm._v(" "),_c('silentbox-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_group_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1beef97c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_group_vue__ = __webpack_require__(238);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1beef97c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"silentbox-group"}},[_vm._t("default"),_vm._v(" "),_c('silentbox-overlay')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_503b9e4d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__(241);
function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_503b9e4d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"silentbox-item",attrs:{"src":_vm.src},on:{"click":_vm.openSilentBoxOverlay}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04796bdc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04796bdc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"results"}},[_vm._v("\n  "+_vm._s(_vm.getGrade())+"\n  "+_vm._s(_vm.getOwnGrade())+"\n  "+_vm._s(_vm.getSumPerChapter())+"\n  "+_vm._s(_vm.smoothScroll())+"\n  "),_vm._m(0),_vm._v(" "),_c('main',[_c('h1',[_vm._v("Test je werkgeluk quiz")]),_vm._v(" "),_c('div',{staticClass:"user user-results"},[(this.grade != null)?_c('div',{staticClass:"left results",class:_vm.classResults},[_c('div',{staticClass:"left-contents"},[_c('div',{staticClass:"label-white-large fade-in"},[_vm._v("Volgens deze test is jouw werkgelukcijfer een")]),_vm._v(" "),_c('div',{staticClass:"response heartBeat animated"},[_c('div',{staticClass:"emoticon",class:_vm.emotionsResults}),_vm._v(_vm._s(_vm.grade))]),_vm._v(" "),_vm._m(1)])]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"menu-tips"},[_c('ul',[_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-1' },attrs:{"href":"#tip-1"},on:{"click":function($event){_vm.mouseClick('#tip-1')}}},[_vm._v("Tips\n          inleiding")])]),_vm._v(" "),_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-2' },attrs:{"href":"#tip-2"},on:{"click":function($event){_vm.mouseClick('#tip-2')}}},[_vm._v("Tip\n          Verbondenheid")])]),_vm._v(" "),_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-3' },attrs:{"href":"#tip-3"},on:{"click":function($event){_vm.mouseClick('#tip-3')}}},[_vm._v("Tip\n          Competentie")])]),_vm._v(" "),_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-4' },attrs:{"href":"#tip-4"},on:{"click":function($event){_vm.mouseClick('#tip-4')}}},[_vm._v("Tip\n          Autonomie")])]),_vm._v(" "),_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-5' },attrs:{"href":"#tip-5"},on:{"click":function($event){_vm.mouseClick('#tip-5')}}},[_vm._v("Tip\n          Maatschappelijke relevantie")])]),_vm._v(" "),_c('li',[_c('a',{class:{ 'active': _vm.tipActive === '#tip-6' },attrs:{"href":"#tip-6"},on:{"click":function($event){_vm.mouseClick('#tip-6')}}},[_vm._v("Tips\n          Afsluiting")])])])]),_vm._v(" "),_c('div',{staticClass:"right tips"},[_c('div',{staticClass:"tips"},[_c('div',{staticClass:"tip",attrs:{"id":"tip-1"}},[_c('p',{staticClass:"explanation"},[_vm._v("De score van de werkgeluktest is gebaseerd op 4 factoren die invloed hebben op je werkgeluk; de relatie\n            met je collega's, hoe goed jij je competenties kan benutten in je functie, de vrijheid die je hebt om te\n            doen wat je leuk vindt en de maatschappelijke relevantie die je werk heeft.")]),_vm._v(" "),_c('p',[_vm._v("Zelf beoordeelde jij jouw werkgeluk met een "),_c('strong',[_vm._v(_vm._s(_vm.ownGrade))]),_vm._v(". Bekijk hier per factor wat jij kunt doen om jouw werkgeluk te vergroten.")]),_vm._v(" "),_c('div',{staticClass:"to-tip"},[_c('div',{staticClass:"label-red"},[_vm._v("Bekijk je tips")]),_vm._v(" "),_c('a',{staticClass:"button down",attrs:{"href":"#tip-2"},on:{"click":function($event){_vm.mouseClick('#tip-2')}}},[_vm._v("Volgende\n              tip")])])]),_vm._v(" "),_c('div',{staticClass:"tip",attrs:{"id":"tip-2"}},[_c('h2',[_vm._v(_vm._s(_vm.tipTitleSolidarity))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipSolidarity)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipLinkTextSolidarity)}}),_vm._v(" "),_c('div',{staticClass:"to-tip"},[_c('div',{staticClass:"label-red"},[_vm._v("Volgende tip")]),_vm._v(" "),_c('a',{staticClass:"button down",attrs:{"href":"#tip-3"},on:{"click":function($event){_vm.mouseClick('#tip-3')}}},[_vm._v("Volgende\n              tip")])])]),_vm._v(" "),_c('div',{staticClass:"tip",attrs:{"id":"tip-3"}},[_c('h2',[_vm._v(_vm._s(_vm.tipTitleCompetence))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipCompetence)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipLinkTextCompetence)}}),_vm._v(" "),_c('div',{staticClass:"to-tip"},[_c('div',{staticClass:"label-red"},[_vm._v("Volgende tip")]),_vm._v(" "),_c('a',{staticClass:"button down",attrs:{"href":"#tip-4"},on:{"click":function($event){_vm.mouseClick('#tip-4')}}},[_vm._v("Volgende\n              tip")])])]),_vm._v(" "),_c('div',{staticClass:"tip",attrs:{"id":"tip-4"}},[_c('h2',[_vm._v(_vm._s(_vm.tipTitleAutonomy))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipAutonomy)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipLinkTextAutonomy)}}),_vm._v(" "),_c('div',{staticClass:"to-tip"},[_c('div',{staticClass:"label-red"},[_vm._v("Volgende tip")]),_vm._v(" "),_c('a',{staticClass:"button down",attrs:{"href":"#tip-5"},on:{"click":function($event){_vm.mouseClick('#tip-5')}}},[_vm._v("Volgende\n              tip")])])]),_vm._v(" "),_c('div',{staticClass:"tip",attrs:{"id":"tip-5"}},[_c('h2',[_vm._v(_vm._s(_vm.tipTitleSocial))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipSocial)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.tipLinkTextSocial)}}),_vm._v(" "),_c('div',{staticClass:"to-tip"},[_c('div',{staticClass:"label-red"},[_vm._v("Volgende tip")]),_vm._v(" "),_c('a',{staticClass:"button down",attrs:{"href":"#tip-6"},on:{"click":function($event){_vm.mouseClick('#tip-6')}}},[_vm._v("Volgende\n              tip")])])]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo logo-desktop",attrs:{"src":__webpack_require__(30),"alt":"Driessen Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo logo-mobile",attrs:{"src":__webpack_require__(31),"alt":"Driessen Logo"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speech-bubble explanation flipInX animated"},[_c('h3',[_vm._v("Deze score is gebaseerd op 4 factoren:")]),_vm._v(" "),_c('ul',{staticClass:"checklist checklist--green"},[_c('li',[_vm._v("je relatie met collega's")]),_vm._v(" "),_c('li',[_vm._v("je competenties")]),_vm._v(" "),_c('li',[_vm._v("je vrijheid in je werk")]),_vm._v(" "),_c('li',[_vm._v("je manier van mensen gelukkig maken")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip",attrs:{"id":"tip-6"}},[_c('h2',[_vm._v("Vind je werkgeluk bij Driessen")]),_vm._v(" "),_c('p',[_vm._v("Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,\n            het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren\n            of zorg je voor anderen. Werk dat de maatschappij mooier en gelukkiger maakt.")]),_vm._v(" "),_c('p',[_vm._v("Veel werkgeluk toegewenst!")]),_vm._v(" "),_c('div',[_c('a',{staticClass:"button button--margin",attrs:{"href":"https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("bekijk onze vacatures")])]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_vm._v("\n            of   "),_c('a',{staticClass:"button",attrs:{"href":"https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("schrijf je gratis in")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMjAgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjIgKDU3NTE5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5GaWxsIDE0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlRhYmxldC1Db3B5LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MC4wMDAwMDAsIC01MC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTU4Ljg1MzU4MDMsNTguNzA5NzU2NiBDNTIuNzc5NDkyOCw1OC43MDk3NTY2IDUwLDYzLjMxOTE2IDUwLDcwLjM4Njk5MTMgQzUwLDc3Ljg2MDk5MjQgNTMuMDY3NjEwOSw4MiA2MC44MzgzMjcsODIgQzY2LjA3NDA4NzUsODIgNzAsODAuMTUxNzE5IDcwLDgwLjE1MTcxOSBMNzAsNTAgTDY0LjM1NjI3MzgsNTAuOTc4MjU2OCBMNjQuMzU2MjczOCw3Ny4wNTc1NzI5IEM2My44NjQ3NzgyLDc3LjIxODEzNzkgNjIuNjM3ODU0OSw3Ny41Mzk4NjI1IDYwLjgzODMyNyw3Ny41Mzk4NjI1IEM1Ni42MjU1MDY5LDc3LjUzOTg2MjUgNTUuNjQ0MzMxNSw3NC42ODY1NjM4IDU1LjY0NDMzMTUsNzAuMzg2OTkxMyBDNTUuNjQ0MzMxNSw2Ni4wODc0MTg3IDU2LjcwNzIyMTEsNjMuMjc0NTU4NiA2MC44MzgzMjcsNjMuMjc0NTU4NiBDNjEuMjEzNjA2OSw2My4yNzQ1NTg2IDYxLjU2MjI1NDEsNjMuMjkzNTg4NiA2MS44OTAzMjE0LDYzLjMyMDk0NDEgTDYxLjEwMjgzODgsNTguOTQxMDg5IEM2MC4yNTE4MDA3LDU4LjcyNDAyOSA1OS4xNTc0MzYsNTguNzA5NzU2NiA1OC44NTM1ODAzLDU4LjcwOTc1NjYiIGlkPSJGaWxsLTE0Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebaseConfigProd__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebaseConfigAcc__ = __webpack_require__(224);





var firebaseApp = null;

var host = window.location.hostname;

// Use PROD Firebase only for PROD environment.
if (host === 'www.testjewerkgeluk.nl') {
  firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_2__firebaseConfigProd__["a" /* default */]);
} else {
  firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_3__firebaseConfigAcc__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp.firestore());
var firestore = firebaseApp.firestore();
var settings = { timestampsInSnapshots: true };
firestore.settings(settings);

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

},[207]);


// WEBPACK FOOTER //
// static/js/app.df0151c01b83a668a7d6.js